// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:41.312Z
// Property: Ascend at Savannah (ID: 6737460151192632)
// Collections: 26 amenities, 13 floorplans (live), 38 photos, 74 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192632",
  "property_external_id": "4857241",
  "property_zillow_url": "https://www.zillow.com/apartments/savannah-ga/ascend-at-savannah/5XtP3x/",
  "property_apartments_url": "https://www.apartments.com/ascend-savannah-savannah-ga/ztx8c8w",
  "property_google_business_url": "https://www.google.com/maps/place/Ascend+at+Savannah/data=!4m2!3m1!1s0x0:0xf1617725bee5999b?sa=X&ved=2ahUKEwi4ovKbyLySAxXCLVkFHXRICcQQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321198229",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ascend-at-savannah",
  "property_name": "Ascend at Savannah",
  "property_website_url": "https://www.ascendatsavannahapartments.com/",
  "property_domain": "https://www.ascendatsavannahapartments.com/",
  "property_address": "10714 Abercorn St",
  "property_full_address": "10714 Abercorn St, Savannah, GA 31419",
  "property_address_1": "10714 Abercorn St",
  "property_address_2": null,
  "property_address_city": "Savannah",
  "property_address_state": "GA",
  "property_address_zip_full": "31419-1421",
  "property_address_zip": "31419",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Windsor Forest",
  "property_address_latitude": "31.9794678",
  "property_address_longitude": "-81.13167330000002",
  "property_email": "ascendsavannah@rreafresidential.com",
  "property_phone": "(912) 925-5519",
  "property_call_tracking_phone": "912-913-5741",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover Ascend at Savannah, where comfort meets convenience. Explore our diverse floor plans—one, two, or three-bedroom apartments—alongside premium amenities like a fitness center, clubhouse, playground, and sports courts. Experience 24-hour access and furnished units. Find your new home today—browse our availability or schedule a tour to visit!",
  "property_long_description": "**Welcome to Ascend at Savannah: Your Ideal Apartment Community in Beautiful Savannah, GA**\n\nDiscover the perfect blend of comfort and convenience at Ascend at Savannah, where our stylish one, two, and three-bedroom floor plans cater to a variety of lifestyles and family sizes. Each spacious apartment is designed with modern living in mind, featuring available furnished units that ensure a seamless move-in experience.\n\nAt Ascend at Savannah, we pride ourselves on offering an array of exceptional amenities that enhance your living experience. Stay active and engaged in our state-of-the-art fitness center, or unwind in our sauna after a rigorous workout. Families will appreciate our inviting playground, perfect for children to explore and make lasting memories.\n\nOur clubhouse and lounge spaces provide the ideal backdrop for social gatherings, while our 24-hour access ensures that your lifestyle is as flexible as your needs. For the sports enthusiasts, take advantage of our basketball and tennis courts to enjoy some friendly competition with your neighbors.\n\nConvenience is key, and our laundry facilities on-site make chore days a breeze. Whether you're looking to unwind in your stylish new home or socialize with friends, Ascend at Savannah has it all.\n\nDon’t wait to escape to your new sanctuary in Savannah! Find your new home today by browsing our availability or schedule a tour to experience firsthand what community living is all about. Join us at Ascend at Savannah and elevate your lifestyle today!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-b56d-7558-88b5-eb053717596a.webp",
  "property_featured_image_media": {
    "alt_text": "Ascend at Savannah monument sign with landscaping.",
    "public_id": "019e6995-b56d-7558-88b5-eb053717596a",
    "storage_key": "property/6737460151192632/019e6995-b56d-7558-88b5-eb053717596a.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "160",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.625",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$250\nApplication Fee\n$75",
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No breed restrictions, maximum of 2 pets per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://ascendatsavannah.loftliving.com/login",
  "property_apply_now_url": "https://8747930.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-4618-714d-8706-048fb1a4369c.webp",
  "property_primary_logo_media": {
    "alt_text": "Ascend at Savannah logo",
    "public_id": "019e1de7-4618-714d-8706-048fb1a4369c",
    "storage_key": "property/6737460151192632/019e1de7-4618-714d-8706-048fb1a4369c.webp",
    "width": 689,
    "height": 241
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-446f-707c-8727-ba305b6cdd2f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ascend at Savannah logo.",
    "public_id": "019e1de7-446f-707c-8727-ba305b6cdd2f",
    "storage_key": "property/6737460151192632/019e1de7-446f-707c-8727-ba305b6cdd2f.webp",
    "width": 689,
    "height": 241
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-446f-707c-8727-ba305b6cdd2f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ascend at Savannah logo.",
    "public_id": "019e1de7-446f-707c-8727-ba305b6cdd2f",
    "storage_key": "property/6737460151192632/019e1de7-446f-707c-8727-ba305b6cdd2f.webp",
    "width": 689,
    "height": 241
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-4618-714d-8706-048fb1a4369c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ascend at Savannah logo",
    "public_id": "019e1de7-4618-714d-8706-048fb1a4369c",
    "storage_key": "property/6737460151192632/019e1de7-4618-714d-8706-048fb1a4369c.webp",
    "width": 689,
    "height": 241
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#072b74",
  "property_secondary_color": "#d0dbe2",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "744 - 1050",
  "property_sqft_min": "744",
  "property_sqft_max": "1050",
  "property_price_range": "1055 - 1530",
  "property_price_min": "1055",
  "property_price_max": "1530",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/AscendSavannah",
  "property_instagram_url": "https://www.instagram.com/ascend_at_savannah/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIzRf5Ox0-4gRm5nlviV3YfE",
  "property_youtube_url": "https://www.youtube.com/watch?t=380&v=0NqJofyOkJY",
  "property_yelp_url": "https://www.yelp.com/biz/ascend-wellness-savannah",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ascend at Savannah",
  "property_home_romance_title": "Embrace a New Beginning in Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p>Let us introduce you to a higher standard of apartment home living in Savannah, Georgia! Ascend at Savannah is nestled between Highway 204 and Harry S Truman, making it easy to explore downtown or exciting recreational areas. Enjoy the beauty of southeast Georgia with all of life’s modern conveniences. Appetizing dining options, plentiful shopping centers, and entertainment hotspots are all within reach of our premier location.</p>",
  "property_home_floorplans_blurb": "<p>Located in Savannah, GA we offer stunning 1-, 2- and 3-bedroom apartment homes with open floorplans, contemporary design, and stylish finishes. Ascend at Savannah is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Ascend at Savannah, your ideal lifestyle awaits! Choose from stylish one, two, or three-bedroom apartments featuring granite-style countertops, modern appliances, and cozy balconies. Enjoy amenities like a shimmering pool, a leash-free pet park, and vibrant resident events—all just moments from Harry S. Truman Parkway. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Ascend at Savannah, where our diverse floor plans—one, two, and three bedrooms—meet coastal charm. Explore local favorites and nearby attractions that make our Savannah, GA community truly special. **See what's around our community and connect with the lifestyle you’ve been dreaming of!**",
  "property_home_reviews_blurb": "At Ascend at Savannah, residents rave about our exceptional management team, stating they “really care about their tenants” and go above and beyond for their comfort. With a prime location and a commitment to cleanliness and safety, it's no wonder our community feels like home. See what our residents have to say!",
  "property_neighborhood_blurb": "<p>Located in Savannah, GA we offer stunning 1-, 2- and 3-bedroom apartment homes with open floorplans, contemporary design, and stylish finishes. Ascend at Savannah is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Rise to new heights in a pet-friendly apartment community. Our lush setting cultivates the perfect atmosphere to relax and enjoy life’s simple pleasures, and your four-legged friends will love it too. They can romp and play at our bark park, and you can take advantage of our other amenities, like the shimmering swimming pool, outdoor kitchen, and grills. Ascend at Savannah is everything you didn’t know you were looking for, so call to schedule a tour today and see for yourself!</p>",
  "property_applynow_blurb": "Discover your perfect home at Ascend at Savannah in vibrant Savannah, GA. Choose from spacious one, two, or three-bedroom floor plans. Enjoy exceptional amenities like a fitness center, clubhouse, and playground. Ready to elevate your lifestyle? Apply now and lease online today! Your dream apartment awaits!",
  "property_contactus_blurb": "At Ascend at Savannah in beautiful Savannah, GA, choose from our thoughtfully designed one, two, or three-bedroom floor plans to suit your lifestyle. Explore spacious layouts and modern amenities. Have questions? Contact our leasing team today and discover your perfect home at Ascend at Savannah!",
  "property_faqs_blurb": "Discover the ideal living space at Ascend at Savannah, where our expertly designed one, two, and three-bedroom floor plans cater to your lifestyle. For answers to your questions and to learn more about our vibrant community, browse our FAQs page today! Experience upscale living in beautiful Savannah, GA.",
  "property_floorplans_blurb": "<p>Our one, two, and three bedroom apartments for rent in Savannah, GA will elevate your quality of life and redefine the meaning of home. Each floor plan includes a balcony or patio where you can unwind and take in the views. Some of the new features coming soon to select homes include granite-style countertops, modern black appliances, and built-in USB ports. With designer details like these, our cozy interiors are sure to fit your needs.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Ascend at Savannah, where a variety of exceptional floor plans—including one, two, and three-bedroom apartments—await. Enjoy top-notch amenities like a fitness center, clubhouse, and playground. Use our interactive community map to explore available units and pricing today! Your new lifestyle starts here in Savannah, GA!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats &amp; Tails Socials. Learn more about our pet policy through our partner, PetScreening.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at Ascend at Savannah in beautiful Savannah, GA! Choose from our stylish one, two, or three-bedroom floor plans designed to fit your lifestyle. Great friends make great neighbors—refer a friend to our community today and experience exceptional living together! View all options now!",
  "property_residentaccess_blurb": "Welcome to Ascend at Savannah, where our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Conveniently located in beautiful Savannah, GA, our resident portal allows you to easily pay rent, schedule maintenance, and more! Access your resident portal today to enhance your living experience!",
  "property_reviews_blurb": "At Ascend at Savannah, our residents rave about the exceptional management team dedicated to their comfort. With glowing reviews highlighting the \"amazing\" staff that genuinely cares, residents appreciate the immaculate surroundings and safety in a prime location. Join our community and see what makes us a cherished home!",
  "property_created_at": "1752257255110",
  "property_scheduletour_blurb": "Explore Ascend at Savannah, where our diverse floor plans include one, two, and three-bedroom apartments designed for your lifestyle. Nestled in beautiful Savannah, GA, we invite you to schedule a tour today. Discover why our residents love calling this community home—check out their testimonials now!",
  "property_thankyou_blurb": "Thank you for your interest in Ascend at Savannah! Our charming community offers exquisite one, two, and three-bedroom floor plans tailored to fit your lifestyle. Explore the perfect space in beautiful Savannah, GA. A team member will reach out to you shortly to assist you with your apartment search!",
  "property_virtualtours_blurb": "<p>At Ascend at Savannah, we make finding your new home quick &amp; easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home &amp; the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Ascend at Savannah",
  "property_seo_title_home": "Ascend at Savannah | Apartments in Savannah, GA",
  "property_seo_description_home": "Discover your ideal living space at Ascend at Savannah, where comfort meets convenience in the heart of Savannah, GA. Choose from our spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities including a fitness center, clubhouse, and 24-hour access. Relax at our sauna, hit the courts for a game of basketball or tennis, or let the kids enjoy the playground. With furnished units available and laundry facilities on-site, we have everything you need to feel right at home. Find your new home today at Ascend at Savannah!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Savannah, GA",
  "property_seo_description_floorplans": "Discover your ideal living space at Ascend at Savannah! Explore our stunning one, two, and three-bedroom floor plans designed for comfort and style. Whether you need a cozy retreat or a spacious family home, we have the perfect option for you. Browse our available apartment homes today and find your dream floor plan in beautiful Savannah, GA!",
  "property_seo_title_amenities": "Amenities | Savannah, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover the elevated living experience at Ascend at Savannah in beautiful Savannah, GA. Explore our thoughtfully designed one, two, and three-bedroom floor plans alongside top-notch amenities including a fitness center, playground, clubhouse, and more! Enjoy 24-hour access, furnished units, and recreational options like a sauna and sports courts. Experience all that our vibrant community has to offer. Visit now and elevate your lifestyle with us!",
  "property_seo_title_gallery": "Gallery | Apartments in Savannah, GA",
  "property_seo_description_gallery": "Discover your future home at Ascend at Savannah! Explore our stunning photo gallery featuring spacious one, two, and three-bedroom apartment floor plans. Enjoy top-notch amenities, including a fitness center, clubhouse, playground, and sports courts. Picture yourself living in comfort with furnished units, 24-hour access, and a relaxing sauna. Don’t just imagine the lifestyle—see it! Visit us today!",
  "property_seo_title_virtualtours": "Virtual Tours | Ascend at Savannah Apartments",
  "property_seo_description_virtualtours": "Discover your new home at Ascend at Savannah in beautiful Savannah, GA! Explore our diverse floor plans, featuring one, two, and three-bedroom options designed for modern living. Take a virtual tour of our community and apartments for rent today and experience the perfect blend of comfort and convenience. Your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Ascend at Savannah Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Ascend at Savannah in beautiful Savannah, GA! Explore our diverse floor plans—including one, two, and three-bedroom options—designed to fit your lifestyle. Enjoy premium amenities such as a fully-equipped fitness center, relaxing sauna, and fun-filled playground. With 24-hour access to our clubhouse, lounge, and sports courts, there's something for everyone. Use our interactive community map to find available apartments, view pricing, and start your journey to modern living today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Savannah, GA",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Ascend at Savannah! Explore our one, two, and three-bedroom floor plans while uncovering local favorites and nearby attractions. Experience the best of Savannah, GA – see what's around our community today!",
  "property_seo_title_contact": "Contact Us | Ascend at Savannah",
  "property_seo_description_contact": "Discover your perfect home at Ascend at Savannah, offering spacious one, two, and three-bedroom floor plans tailored to fit your lifestyle. Located in the heart of Savannah, GA, our vibrant community combines comfort and convenience. Have questions? Contact our leasing team today to learn more about your future apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Savannah, GA",
  "property_seo_description_faqs": "Discover your ideal home at Ascend at Savannah in Savannah, GA! Explore our diverse floor plans, including one, two, and three-bedroom options. Enjoy top-notch amenities like a fitness center, playground, and 24-hour access to a luxurious clubhouse and lounge. Have questions? Browse our FAQs page to find answers about our community and start your journey to comfortable living today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Savannah, GA",
  "property_seo_description_reviews": "Discover the vibrant community at Ascend at Savannah, GA! Explore our diverse floor plans, including one, two, and three-bedroom apartments, along with a wide range of amenities like a fully-equipped fitness center, clubhouse, playground, and sports courts. Don’t just take our word for it—see what our residents have to say about their experience living here! Join us and experience the perfect blend of comfort and convenience.",
  "property_seo_title_applynow": "Apply Now | Apartments in Savannah, GA",
  "property_seo_description_applynow": "Discover your dream home at Ascend at Savannah in Savannah, GA! Choose from our spacious one, two, and three-bedroom floor plans, complete with modern amenities like a fitness center, clubhouse, and 24-hour access. Enjoy leisurely days at our playground, relax in the sauna, or stay active on our basketball and tennis courts. Explore our furnished units for ultimate convenience. Don’t wait—apply now to lease your perfect apartment online today!",
  "property_seo_title_residentaccess": "Resident Access | Ascend at Savannah",
  "property_seo_description_residentaccess": "\"Log in to your resident portal at Ascend at Savannah! Effortlessly pay rent, schedule maintenance, and manage your community living in beautiful Savannah, GA. Experience convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Ascend at Savannah",
  "property_seo_description_referafriend": "\"Discover the charm of Ascend at Savannah! Refer a friend today and enjoy exclusive rewards while creating a vibrant community. Great friends make great neighbors—join us in Savannah, GA, where the perfect home awaits! 🌳🏡\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Ascend at Savannah",
  "property_seo_description_scheduletour": "Discover your new home at Ascend at Savannah! Nestled in the heart of Savannah, GA, our vibrant apartment community offers modern amenities and a welcoming atmosphere. Schedule a tour of our community today and experience the perfect blend of comfort and style!",
  "property_seo_title_privacy": "Privacy Policy | Ascend at Savannah",
  "property_seo_description_privacy": "\"At Ascend at Savannah, your privacy matters! Discover our commitment to safeguarding your personal information. Explore our comprehensive privacy policy and learn how we protect your data while you enjoy luxury living in beautiful Savannah, GA. View our privacy policy now!\"",
  "property_seo_title_accessibility": "Website Accessibility | Ascend at Savannah",
  "property_seo_description_accessibility": "\"Discover Ascend at Savannah, where digital inclusion is our priority. Explore our comprehensive Accessibility Statement to learn how we ensure a welcoming environment for all residents and visitors. Join our vibrant community in beautiful Savannah, GA, and experience inclusive living today!\"",
  "property_seo_title_sitemap": "Sitemap | Ascend at Savannah",
  "property_seo_description_sitemap": "Explore the Ascend at Savannah community in beautiful Savannah, GA! Discover amenities, floor plans, and the vibrant lifestyle we offer. View our comprehensive sitemap to navigate our apartment offerings and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Ascend at Savannah",
  "property_seo_description_thankyou": "Thank you for your interest in Ascend at Savannah! Your submission has been received, and a member of our dedicated team will reach out to you shortly. Discover the vibrant lifestyle and luxury amenities that await you in our beautiful Savannah, GA community!",
  "property_seo_title_pets": "Pet Policy | Apartments in Savannah, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293617079",
  "amenities": [
    {
      "id": "custom_12154eb2-cdd0-4557-8e85-8a1cdbc89e94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Online Customer Service (Includes Rent Pay)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e106287b-ca2b-42f5-936e-778f86695004",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Harry S. Truman Parkway",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6a8ce9b-2bea-4186-a56c-9e748c7abfe4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Clothes Care Centers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_999f637c-01b2-4432-afcd-9b641ed7130a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_263d0b52-7b01-4989-ac2a-9b386f5d084e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly (Restrictions Apply)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88501c82-d111-4ecb-84a7-27ab0567e3e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Play Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70251aa5-04ae-48d3-8968-9ee11aba2855",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally Managed",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6d54bbc-1345-48a7-9bb3-2a8b595b57fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c71e79d5-7f0b-4146-a7e9-168cddc2bb57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48149a12-08b2-4a26-93b4-9791ed7dea8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_766e4ed9-86d8-4255-8772-e33e1d1ae002",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e479b75f-9d2b-4626-8fde-83afdc20c1d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Classic White and Oak Kitchen Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e66ef591-b6a7-45c7-ad48-00524aa37fc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49699380-c965-4bfe-bcb5-4b977023024b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "White Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3289f76-f067-4834-ba72-f883aca06234",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96c2e034-ebc4-48d1-aa87-9229acc324ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Area with picnic tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6604a5bc-d4f4-4523-af00-c5e5b899c859",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Brushed Nickel Lighting and Hardware*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1db1a37c-efdd-4dce-aa02-6b0ecc535208",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Built‑in USB Ports*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ef646d6-10bb-4716-9f9a-cf2d3aa4fcde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Granite‑style Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c04b61b-472c-4636-ba06-15c86dd544a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Modern Black Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cace596b-5300-4a70-bb73-cc52e11095d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Outdoor Kitchen and Grills",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7bc7b9d-e7c3-46aa-9c1e-5eedc9207383",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Over‑the‑Range Microwave*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf9038cf-0356-467a-aafb-79e6ead7ce0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Tile Kitchen Backsplash*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd38fec3-2c72-45d8-9992-475e65c940fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: White Shaker‑style Cabinetry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87dda390-e7b0-4f99-a2c4-3c03c89e9e13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "COMING SOON: Wood Designed Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2df69c89-d430-42eb-a744-b18ea31fd53a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "external_id": "false",
      "title": "Nature Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_534143c6-314c-4a08-9a16-49232cd82892",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3d70-705d-9a89-93c2e6d0b9aa.webp",
      "image_media": {
        "alt_text": "Living room with sofa, accent chairs, coffee tables, and modern art.",
        "public_id": "019fafbe-3d70-705d-9a89-93c2e6d0b9aa",
        "storage_key": "property/6737460151192632/019fafbe-3d70-705d-9a89-93c2e6d0b9aa.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and well-decorated living room featuring a comfortable sofa, stylish accent chairs, and elegant decor, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, accent chairs, coffee tables, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7a2fdc0-01e9-44e5-98b0-285b7654af92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-38b5-74c9-be14-fb06547a643d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019fafbe-38b5-74c9-be14-fb06547a643d",
        "storage_key": "property/6737460151192632/019fafbe-38b5-74c9-be14-fb06547a643d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Chic and functional kitchen featuring a full suite of black appliances, ample storage with white cabinetry, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19d36ed7-8ada-440f-ba79-af8a58980ecb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3979-70c6-a169-6b0cef12bba9.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstand, closet, and decor.",
        "public_id": "019fafbe-3979-70c6-a169-6b0cef12bba9",
        "storage_key": "property/6737460151192632/019fafbe-3979-70c6-a169-6b0cef12bba9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable queen-sized bed, elegant nightstand, and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "Bedroom with queen bed, nightstand, closet, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6cfb2ab-f6c6-4d01-9609-7fc2e1f40c2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3921-774b-ae8c-35c32a2274a3.webp",
      "image_media": {
        "alt_text": "Living room with a grey sofa, decorative pillows, armchair, coffee table, and a large mirror above the sofa.",
        "public_id": "019fafbe-3921-774b-ae8c-35c32a2274a3",
        "storage_key": "property/6737460151192632/019fafbe-3921-774b-ae8c-35c32a2274a3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, modern decor, and an open view to the kitchen.",
      "link": "",
      "alt_text": "Living room with a grey sofa, decorative pillows, armchair, coffee table, and a large mirror above the sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5eef934e-5787-4db1-8a20-0382d31a7334",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-14ab-7489-bc0d-9b295c57ea62.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings reflected in a pond, surrounded by trees.",
        "public_id": "019e6996-14ab-7489-bc0d-9b295c57ea62",
        "storage_key": "property/6737460151192632/019e6996-14ab-7489-bc0d-9b295c57ea62.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a scenic pond and lush trees, offering a serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings reflected in a pond, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff9fb158-0679-4dec-9411-c261e98fb9b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-38c0-7124-b182-6961d9be2154.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, vanity with granite countertop, and decorative accents.",
        "public_id": "019fafbe-38c0-7124-b182-6961d9be2154",
        "storage_key": "property/6737460151192632/019fafbe-38c0-7124-b182-6961d9be2154.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A clean and contemporary bathroom featuring a white bathtub and toilet, a vanity with a granite countertop, and stylish decorative elements, offering a comfortable and functional space.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, vanity with granite countertop, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1fe9a4b2-4219-46f3-bd18-7d684945bd61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3d5c-7789-af70-331819ecf17c.webp",
      "image_media": {
        "alt_text": "Living room with view of kitchen",
        "public_id": "019fafbe-3d5c-7789-af70-331819ecf17c",
        "storage_key": "property/6737460151192632/019fafbe-3d5c-7789-af70-331819ecf17c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room flows into a modern kitchen, perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Living room with view of kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca5e15c4-d885-44f7-826d-1246e70d5736",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3dc1-75ca-ba88-c693bdc42d5b.webp",
      "image_media": {
        "alt_text": "Clean bathroom with white bathtub, toilet, and vanity with granite countertop.",
        "public_id": "019fafbe-3dc1-75ca-ba88-c693bdc42d5b",
        "storage_key": "property/6737460151192632/019fafbe-3dc1-75ca-ba88-c693bdc42d5b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a white bathtub, toilet, and a vanity with a granite countertop. Ample natural light enters through the window.",
      "link": "",
      "alt_text": "Clean bathroom with white bathtub, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4cf696e-6fb0-4166-bdf0-16455d5e2817",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-1f53-75a9-b20e-bac75898a241.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets.",
        "public_id": "019e6995-1f53-75a9-b20e-bac75898a241",
        "storage_key": "property/6737460151192632/019e6995-1f53-75a9-b20e-bac75898a241.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a refrigerator, microwave, stove, dishwasher, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53022fa2-b500-4ec2-b3c4-d88355db7073",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-8ccf-7666-bf94-074a59ea655c.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for four, featuring a modern wooden table, upholstered chairs, and abstract wall art.",
        "public_id": "019e6995-8ccf-7666-bf94-074a59ea655c",
        "storage_key": "property/6737460151192632/019e6995-8ccf-7666-bf94-074a59ea655c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in your apartment with a spacious dining area, perfect for hosting guests or enjoying a quiet meal.",
      "link": "",
      "alt_text": "Dining area with a table set for four, featuring a modern wooden table, upholstered chairs, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31c7d4d8-05bc-4def-9422-5ee5a03b6a11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-ad85-7093-929a-1d568497c6c0.webp",
      "image_media": {
        "alt_text": "Built-in outdoor grill and counter under a wooden pergola.",
        "public_id": "019e6995-ad85-7093-929a-1d568497c6c0",
        "storage_key": "property/6737460151192632/019e6995-ad85-7093-929a-1d568497c6c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with a built-in grill and spacious counter, perfect for entertaining guests in the community courtyard.",
      "link": "",
      "alt_text": "Built-in outdoor grill and counter under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_777e03c6-247f-41bb-a299-ec2f12301d6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-5081-760b-9a7c-6c61001dde6f.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two armchairs, a coffee table, and a side table with a lamp.",
        "public_id": "019e6995-5081-760b-9a7c-6c61001dde6f",
        "storage_key": "property/6737460151192632/019e6995-5081-760b-9a7c-6c61001dde6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting living room, perfect for relaxation and entertaining guests.",
      "link": "",
      "alt_text": "Living room with a sofa, two armchairs, a coffee table, and a side table with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_deab121c-ff4b-4208-9a1d-bd6a04ba6e52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-8687-7272-9f1d-384205ae98dd.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two chairs, a coffee table, and a painting of sailboats.",
        "public_id": "019e6995-8687-7272-9f1d-384205ae98dd",
        "storage_key": "property/6737460151192632/019e6995-8687-7272-9f1d-384205ae98dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living room, perfect for entertaining guests or enjoying a quiet evening in.",
      "link": "",
      "alt_text": "Living room with a sofa, two chairs, a coffee table, and a painting of sailboats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b30c5b25-8964-426f-840d-d77a9674f8a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-1847-7620-a16b-10720e9e05e6.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with grass in the foreground and an outdoor staircase.",
        "public_id": "019e6996-1847-7620-a16b-10720e9e05e6",
        "storage_key": "property/6737460151192632/019e6996-1847-7620-a16b-10720e9e05e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing its architecture and manicured lawn.",
      "link": "",
      "alt_text": "Exterior of an apartment building with grass in the foreground and an outdoor staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c3f721b-f4ec-48f8-be72-52ee8cd07d07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-1ce6-766a-987f-a929ee4e8609.webp",
      "image_media": {
        "alt_text": "Ascend at Savannah building entrance with awning and signage.",
        "public_id": "019e6996-1ce6-766a-987f-a929ee4e8609",
        "storage_key": "property/6737460151192632/019e6996-1ce6-766a-987f-a929ee4e8609.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Ascend at Savannah, featuring a prominent building entrance with a covered awning and clear signage. The surrounding landscape includes manicured bushes and flowering plants, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "Ascend at Savannah building entrance with awning and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_121a890f-a010-4d8b-bc77-627e5882c5a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-290e-7278-9581-4cdf54ee2c10.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two armchairs, and a coffee table.",
        "public_id": "019e6995-290e-7278-9581-4cdf54ee2c10",
        "storage_key": "property/6737460151192632/019e6995-290e-7278-9581-4cdf54ee2c10.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-appointed living room featuring a comfortable sofa, stylish armchairs, and a coffee table, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, two armchairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71f5a6b6-87c9-4622-ae8b-63a7f2fc7cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-153e-72cd-9152-da8831c19b6b.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with a paved driveway and green grass.",
        "public_id": "019e6996-153e-72cd-9152-da8831c19b6b",
        "storage_key": "property/6737460151192632/019e6996-153e-72cd-9152-da8831c19b6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing the architecture and entryways.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with a paved driveway and green grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8afa6ff-4097-4e63-b281-8c4ef510949b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-0b00-72f9-9143-8049e7c6e981.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with manicured lawns and trees.",
        "public_id": "019e6996-0b00-72f9-9143-8049e7c6e981",
        "storage_key": "property/6737460151192632/019e6996-0b00-72f9-9143-8049e7c6e981.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, featuring manicured lawns, large trees, and architectural details.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69012140-f10f-4344-a135-cc6d4daa1cb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-04da-75fe-83b2-2678612cbb10.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with manicured lawns and landscaping.",
        "public_id": "019e6996-04da-75fe-83b2-2678612cbb10",
        "storage_key": "property/6737460151192632/019e6996-04da-75fe-83b2-2678612cbb10.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of apartment buildings, featuring lush green lawns and attractive landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with manicured lawns and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_220a79ba-eb52-4859-a27d-cade7bacfba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6996-05db-74d6-ba35-164be709c5fd.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with brick and white siding, orange accents, and decorative panels.",
        "public_id": "019e6996-05db-74d6-ba35-164be709c5fd",
        "storage_key": "property/6737460151192632/019e6996-05db-74d6-ba35-164be709c5fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of the apartment buildings features a mix of brick and white siding, accented by orange trim and decorative panels, creating a modern and inviting facade.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with brick and white siding, orange accents, and decorative panels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ecd864a2-0d93-4830-a826-612fff8fc907",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-fe2c-776e-b32d-9380d6df67b6.webp",
      "image_media": {
        "alt_text": "Interior of a leasing office with a desk, chairs, and filing cabinet.",
        "public_id": "019e6995-fe2c-776e-b32d-9380d6df67b6",
        "storage_key": "property/6737460151192632/019e6995-fe2c-776e-b32d-9380d6df67b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly staff is ready to assist you with all your needs.",
      "link": "",
      "alt_text": "Interior of a leasing office with a desk, chairs, and filing cabinet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4aa887bb-db65-4ded-b267-09b3692ad823",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-b56d-7558-88b5-eb053717596a.webp",
      "image_media": {
        "alt_text": "Ascend at Savannah monument sign with landscaping.",
        "public_id": "019e6995-b56d-7558-88b5-eb053717596a",
        "storage_key": "property/6737460151192632/019e6995-b56d-7558-88b5-eb053717596a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Ascend at Savannah, where comfort and convenience meet in a beautifully landscaped community. Discover your new home today.",
      "link": "",
      "alt_text": "Ascend at Savannah monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e85bc39c-c467-419f-ab9a-b9a199882b2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-c370-72c3-bc2f-7c2a90dc65b8.webp",
      "image_media": {
        "alt_text": "Interior of a multifamily property leasing office, featuring two plush chairs in the waiting area and a desk with computers and office supplies.",
        "public_id": "019e6995-c370-72c3-bc2f-7c2a90dc65b8",
        "storage_key": "property/6737460151192632/019e6995-c370-72c3-bc2f-7c2a90dc65b8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office. Sit back and relax in our comfortable waiting area or speak with our friendly staff at the front desk to learn more about our community.",
      "link": "",
      "alt_text": "Interior of a multifamily property leasing office, featuring two plush chairs in the waiting area and a desk with computers and office supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_474a16ff-f3e7-4e80-af79-dd294277bd2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-b1c0-72f2-85d6-48a39e0db366.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019e6995-b1c0-72f2-85d6-48a39e0db366",
        "storage_key": "property/6737460151192632/019e6995-b1c0-72f2-85d6-48a39e0db366.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aed89a36-c509-4ede-8dfc-e73af77f1163",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-a939-7173-81dc-6a972cef0284.webp",
      "image_media": {
        "alt_text": "Close up of a bed with yellow and blue leaf patterned pillows and comforter, flanked by nightstands with lamps.",
        "public_id": "019e6995-a939-7173-81dc-6a972cef0284",
        "storage_key": "property/6737460151192632/019e6995-a939-7173-81dc-6a972cef0284.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and stylish bedroom featuring a plush headboard, decorative wall art, and matching bedside lamps.",
      "link": "",
      "alt_text": "Close up of a bed with yellow and blue leaf patterned pillows and comforter, flanked by nightstands with lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bb14b01d-f3cc-48d2-9fce-37322ee9385e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-8c66-7059-aae6-4df68357086f.webp",
      "image_media": {
        "alt_text": "Closet with hanging clothes and storage baskets.",
        "public_id": "019e6995-8c66-7059-aae6-4df68357086f",
        "storage_key": "property/6737460151192632/019e6995-8c66-7059-aae6-4df68357086f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A view of a closet with a sliding door, showing hanging space and storage baskets on a shelf. Includes a bedside table and lamp.",
      "link": "",
      "alt_text": "Closet with hanging clothes and storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_364f3ed7-17a0-418f-9310-faa160fbed29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-a36b-751c-aeba-8cb08d646b0a.webp",
      "image_media": {
        "alt_text": "Children's bedroom with a twin bed, nightstand, and a small table with chairs.",
        "public_id": "019e6995-a36b-751c-aeba-8cb08d646b0a",
        "storage_key": "property/6737460151192632/019e6995-a36b-751c-aeba-8cb08d646b0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This charming bedroom is perfect for a child, featuring a comfortable twin bed, a nightstand with a lamp, and a fun play area with a table and chairs.",
      "link": "",
      "alt_text": "Children's bedroom with a twin bed, nightstand, and a small table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f74113c-e852-4dd9-b6ce-d278330a138c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-9678-70ee-90f2-6150db85a1af.webp",
      "image_media": {
        "alt_text": "A bright bathroom with a vanity, toilet, and blue towels.",
        "public_id": "019e6995-9678-70ee-90f2-6150db85a1af",
        "storage_key": "property/6737460151192632/019e6995-9678-70ee-90f2-6150db85a1af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and modern bathroom featuring a vanity with a granite countertop, a sink with a chrome faucet, and a mirror. The space is accented with artwork of a beach scene and plush blue towels.",
      "link": "",
      "alt_text": "A bright bathroom with a vanity, toilet, and blue towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c45f2baa-13c5-4841-818a-15edf9b37433",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-4b81-7778-8105-b4c365e04b95.webp",
      "image_media": {
        "alt_text": "Bedroom with blue comforter, dresser, and a child's table.",
        "public_id": "019e6995-4b81-7778-8105-b4c365e04b95",
        "storage_key": "property/6737460151192632/019e6995-4b81-7778-8105-b4c365e04b95.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Comfortable bedroom featuring a queen-size bed with a blue comforter, a spacious dresser, and a fun child-sized table and chairs by the window.",
      "link": "",
      "alt_text": "Bedroom with blue comforter, dresser, and a child's table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26e73070-f58b-4f22-8cf0-c58407377148",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-44c6-7438-aad7-72193e0d5a57.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-sized bed, yellow curtains, and beige carpet.",
        "public_id": "019e6995-44c6-7438-aad7-72193e0d5a57",
        "storage_key": "property/6737460151192632/019e6995-44c6-7438-aad7-72193e0d5a57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-sized bed, yellow curtains, and beige carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90d1b68f-4553-4106-bd20-480ef6ccdce5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-2a43-767f-a21a-a4303a352c54.webp",
      "image_media": {
        "alt_text": "Bathroom with shower, toilet, sink, and mirror.",
        "public_id": "019e6995-2a43-767f-a21a-a4303a352c54",
        "storage_key": "property/6737460151192632/019e6995-2a43-767f-a21a-a4303a352c54.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a patterned shower curtain, a framed ocean-themed print, and a granite vanity top.",
      "link": "",
      "alt_text": "Bathroom with shower, toilet, sink, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d148af97-5013-49e2-bfbc-9575a2f2396f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-3dcf-71af-b490-72a3c3779639.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a black refrigerator, microwave, stove, sink, and a wooden dining table with chairs.",
        "public_id": "019e6995-3dcf-71af-b490-72a3c3779639",
        "storage_key": "property/6737460151192632/019e6995-3dcf-71af-b490-72a3c3779639.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and spacious kitchen and dining area featuring modern appliances and a charming wooden dining table, perfect for enjoying meals at home.",
      "link": "",
      "alt_text": "Kitchen and dining area with a black refrigerator, microwave, stove, sink, and a wooden dining table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13c140c3-9802-48c2-9a3b-f9eaca38ca23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-3f68-756a-a532-e48b1dfaa46c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, nightstands, lamps, and a closet.",
        "public_id": "019e6995-3f68-756a-a532-e48b1dfaa46c",
        "storage_key": "property/6737460151192632/019e6995-3f68-756a-a532-e48b1dfaa46c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, featuring plush carpeting and ample closet space.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, nightstands, lamps, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46354ffb-50c5-4f8c-9189-0ad915ea7ecf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-2fd2-7135-9892-1cb5a07ef4d2.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment entrance with a small table and chairs.",
        "public_id": "019e6995-2fd2-7135-9892-1cb5a07ef4d2",
        "storage_key": "property/6737460151192632/019e6995-2fd2-7135-9892-1cb5a07ef4d2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on the patio of your apartment. This outdoor space includes a small table and two chairs.",
      "link": "",
      "alt_text": "Exterior of an apartment entrance with a small table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f38e2501-e47f-420c-9092-3573c0f56fa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e6995-1d5f-7432-8d07-096d45783f19.webp",
      "image_media": {
        "alt_text": "Empty closet with shelf and hanging rod.",
        "public_id": "019e6995-1d5f-7432-8d07-096d45783f19",
        "storage_key": "property/6737460151192632/019e6995-1d5f-7432-8d07-096d45783f19.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with a shelf and hanging rod, ready for your personal belongings.",
      "link": "",
      "alt_text": "Empty closet with shelf and hanging rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f0f0fca-3521-46ec-9de4-a6479c1aa94a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3d08-746d-828d-2cace66f6371.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019fafbe-3d08-746d-828d-2cace66f6371",
        "storage_key": "property/6737460151192632/019fafbe-3d08-746d-828d-2cace66f6371.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a refrigerator, oven, microwave, and dishwasher, with ample cabinet space and stylish backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e36ba20-5b85-4f25-9f6b-4c5ce58ddbb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-38c5-74f8-83d8-0563ee1f9d60.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, dishwasher, refrigerator, and oven.",
        "public_id": "019fafbe-38c5-74f8-83d8-0563ee1f9d60",
        "storage_key": "property/6737460151192632/019fafbe-38c5-74f8-83d8-0563ee1f9d60.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in our modern apartment kitchens, featuring sleek white cabinetry, elegant granite countertops, and a full suite of appliances including a dishwasher, refrigerator, and oven.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, dishwasher, refrigerator, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_618dd45e-f630-4886-bde6-b4e9f8f44f3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019fafbe-3d6a-70bd-aa58-08d413aee9c8.webp",
      "image_media": {
        "alt_text": "Bedroom with light gray walls and wood-look flooring.",
        "public_id": "019fafbe-3d6a-70bd-aa58-08d413aee9c8",
        "storage_key": "property/6737460151192632/019fafbe-3d6a-70bd-aa58-08d413aee9c8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring light gray walls and modern wood-look flooring. Includes a doorway leading to a closet and another doorway revealing a glimpse of a bathroom.",
      "link": "",
      "alt_text": "Bedroom with light gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_aa0e1460-a504-4a0b-b7ec-9daec6ba6bd0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "11196 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6c81-7641-b76c-618f39d9c75d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6c81-7641-b76c-618f39d9c75d",
        "storage_key": "property/6737460151192632/019e1de9-6c81-7641-b76c-618f39d9c75d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.outback.com/georgia/savannah/11196-abercorn-street?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIwOTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405101028150204075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "31.981075",
      "poi_longitude": "-81.14538259999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-920-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_bKQnoJ-4gRq9bxqkFYZpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_69b7861e-417d-4605-b272-00a7ffb975df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Sushi Hana",
      "poi_type": "Restaurants",
      "poi_address": "11108 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-62fb-7431-88ab-e71a607144b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-62fb-7431-88ab-e71a607144b1",
        "storage_key": "property/6737460151192632/019e1de9-62fb-7431-88ab-e71a607144b1.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "http://www.hanasushiseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9633059342606618392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-hana",
      "poi_latitude": "31.9802698",
      "poi_longitude": "-81.1421219",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-438-6789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3uEtad1-4gRGE9TGG-Ar4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_bd829fb6-9dfc-4231-81be-38b6d0dbb6ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Carey Hilliard's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11111 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "One of a local chain of family drive-ups (with indoor dining too) for BBQ, seafood & Southern eats.",
      "poi_long_description": "One of a local chain of family drive-ups (with indoor dining too) for BBQ, seafood & Southern eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6941-762f-8c7f-5a313d673e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6941-762f-8c7f-5a313d673e20",
        "storage_key": "property/6737460151192632/019e1de9-6941-762f-8c7f-5a313d673e20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://careyhilliards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17763319447254997600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carey-hilliards-restaurant",
      "poi_latitude": "31.9793683",
      "poi_longitude": "-81.14260519999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-925-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEb4IXMB0-4gRYBpsVez8g_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2e9be5fd-056e-465b-b4f2-92d56f440845",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "10408 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6630-7240-b348-ad14bc4b9bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6630-7240-b348-ad14bc4b9bfb",
        "storage_key": "property/6737460151192632/019e1de9-6630-7240-b348-ad14bc4b9bfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.carrabbas.com/georgia/savannah/10408-abercorn-street?y_source=1_MTU1MDI5ODUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4313380771380680115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrabbas-italian-grill",
      "poi_latitude": "31.9874743",
      "poi_longitude": "-81.1307999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-961-7073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVoeR-50-4gRs1UlU_U03Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_5195066e-5790-4b6b-bae0-4d85f8e48e35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11333 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6b32-71bb-bfb6-d828364d1749.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6b32-71bb-bfb6-d828364d1749",
        "storage_key": "property/6737460151192632/019e1de9-6b32-71bb-bfb6-d828364d1749.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/savannah/savannah-abercorn-street/1529?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:savannah-ga-1529_pl:locurl_rd:1399",
      "poi_directions_map_url": "https://maps.google.com/?cid=546195667367978345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "31.980543",
      "poi_longitude": "-81.147307",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-961-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-V008B0-4gRaWVTyxB6lAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b89eeb0b-fee7-4793-ab12-e793431eb45b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Las palmeras seafood & grill",
      "poi_type": "Restaurants",
      "poi_address": "11414 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Casual restaurant and bar in Varsity Park Shopping Center featuring comfort food, cocktails, and karaoke.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6568-73ce-8abe-ae4e1b0bfeca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6568-73ce-8abe-ae4e1b0bfeca",
        "storage_key": "property/6737460151192632/019e1de9-6568-73ce-8abe-ae4e1b0bfeca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://laspalmerasseafoodgrillga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3915798200257389456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-palmeras-seafood--grill",
      "poi_latitude": "31.9818868",
      "poi_longitude": "-81.147409",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-436-5523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRa3AT8R1-4gRkKN0Yre1VzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_26e37ea2-5a10-47d1-b585-0e1e71760122",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "El Potro Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "13051 Abercorn St # A9, Savannah, GA 31419, USA",
      "poi_short_description": "Casual Mexican chain serving up a menu of classic dishes, plus lunch & dinner buffets.",
      "poi_long_description": "Casual Mexican chain serving up a menu of classic dishes, plus lunch & dinner buffets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6501-701e-a498-377856d84e16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6501-701e-a498-377856d84e16",
        "storage_key": "property/6737460151192632/019e1de9-6501-701e-a498-377856d84e16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elpotrorestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13732225351732688808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-potro-mexican-restaurant",
      "poi_latitude": "31.9822719",
      "poi_longitude": "-81.16766539999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-927-9953",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWzX4jUL-4gRqPejcTOqkr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_93f3b493-efc1-4239-8cb1-e8040916b89a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Vincenzo’s Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "12417 White Bluff Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Chill, locally-owned pizza joint offering build-your-own & specialty pies, plus pasta dishes & more.",
      "poi_long_description": "Chill, locally-owned pizza joint offering build-your-own & specialty pies, plus pasta dishes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-62d0-73a3-ab39-38b0a9cf2297.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-62d0-73a3-ab39-38b0a9cf2297",
        "storage_key": "property/6737460151192632/019e1de9-62d0-73a3-ab39-38b0a9cf2297.webp",
        "width": 1015,
        "height": 957
      },
      "poi_business_url": "https://vincenzossavannah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11366627948748608490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vincenzos-pizzeria",
      "poi_latitude": "31.97365799999999",
      "poi_longitude": "-81.133285",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-921-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTlM1ZN0-4gR6hMwe-Vfvp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_461f06aa-25bd-4462-9d84-137522e4dbda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Space Coast Cafe Coffee & Smoothies",
      "poi_type": "Restaurants",
      "poi_address": "12411 White Bluff Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Casual, family-friendly cafe with a laid-back ambiance, serving baked goods and sandwiches alongside roasted coffee and smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6514-74ea-85d0-b8e15358c300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6514-74ea-85d0-b8e15358c300",
        "storage_key": "property/6737460151192632/019e1de9-6514-74ea-85d0-b8e15358c300.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://spacecoastcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16446366876624301134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-coast-cafe-coffee--smoothies",
      "poi_latitude": "31.973839",
      "poi_longitude": "-81.133156",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-495-5019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e098-7389-ae93-b8da54a967cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e098-7389-ae93-b8da54a967cf",
        "storage_key": "property/6737460151192632/019e1de9-e098-7389-ae93-b8da54a967cf.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJLRnQp_x1-4gRTizxpok7PeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1c7b41d3-da0b-425a-b4ee-1e21602494fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Chicken Salad Chick",
      "poi_type": "Restaurants",
      "poi_address": "7400 Abercorn St #512, Savannah, GA 31406, USA",
      "poi_short_description": "Chain outlet specializing in many different types of chicken salads, plus sandwiches, soups & sides.",
      "poi_long_description": "Chain outlet specializing in many different types of chicken salads, plus sandwiches, soups & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-6ed9-7249-be97-979a041a2d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-6ed9-7249-be97-979a041a2d0f",
        "storage_key": "property/6737460151192632/019e1de9-6ed9-7249-be97-979a041a2d0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickensaladchick.com/savannah-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=17011769808122172019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-salad-chick",
      "poi_latitude": "32.0069605",
      "poi_longitude": "-81.1118716",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-200-5286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZ_AEq91-4gRc1LWHYLyFew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_064a5bb4-7c6a-4514-86f7-c9b27fc3269c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Larry's Giant Subs",
      "poi_type": "Restaurants",
      "poi_address": "7805 Abercorn St Suite #24, Savannah, GA 31404, USA",
      "poi_short_description": "Outpost of a counter-serve chain specializing in submarine sandwiches that are made to order.",
      "poi_long_description": "Outpost of a counter-serve chain specializing in submarine sandwiches that are made to order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-769b-759e-943a-f09445e78286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-769b-759e-943a-f09445e78286",
        "storage_key": "property/6737460151192632/019e1de9-769b-759e-943a-f09445e78286.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://larryssubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9389404078734088540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larrys-giant-subs",
      "poi_latitude": "32.0054556",
      "poi_longitude": "-81.11935059999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-352-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_jfG6p1-4gRXJmMLUPdTYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_d2350b3d-94fb-4aa6-b2d9-c5552b1eb74e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Troy Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "10510 Abercorn St STE D, Savannah, GA 31419, USA",
      "poi_short_description": "Cheerful restaurant offering a broad Mediterranean menu that includes kebabs, falafel & seafood.",
      "poi_long_description": "Cheerful restaurant offering a broad Mediterranean menu that includes kebabs, falafel & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7901-772c-96ac-fa102b744748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7901-772c-96ac-fa102b744748",
        "storage_key": "property/6737460151192632/019e1de9-7901-772c-96ac-fa102b744748.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://troymediterraneancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429619318984124613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "troy-mediterranean-cuisine",
      "poi_latitude": "31.9853357",
      "poi_longitude": "-81.1315637",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 912-921-5117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdR7MN-50-4gRxagVODIH1xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_8cc3cf90-64a0-49cd-9e53-15ec79239850",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10530 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Neighborhood chain supplying groceries, plus items such as electronics, furniture, and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-73cb-719b-b246-c51211a66201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-73cb-719b-b246-c51211a66201",
        "storage_key": "property/6737460151192632/019e1de9-73cb-719b-b246-c51211a66201.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4530-savannah-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6767545055041216584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "31.9836499",
      "poi_longitude": "-81.1309838",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-712-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-98cc-744e-b3c2-707a2cc92989.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-98cc-744e-b3c2-707a2cc92989",
        "storage_key": "property/6737460151192632/019e1de7-98cc-744e-b3c2-707a2cc92989.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQj7N-50-4gRSOAuH18m610",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_95b212ae-8ba9-4eca-a31f-2d54f99fa98d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "11114 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-729a-7278-be63-55c4c723c16c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-729a-7278-be63-55c4c723c16c",
        "storage_key": "property/6737460151192632/019e1de9-729a-7278-be63-55c4c723c16c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/GA-Savannah/0403?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-403-_-na-_-0-_-0&y_source=1_MTE4NDM3OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14679957191554096096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.9819181",
      "poi_longitude": "-81.1415762",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-927-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-988b-743d-aacb-7d161c0d6846",
        "storage_key": "property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJaXXXcB0-4gR4NuFuEmvucs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_44c6c165-d99d-4e97-afd5-56764e29d7ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "11180 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-77b6-70dd-b642-f690a80b105f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-77b6-70dd-b642-f690a80b105f",
        "storage_key": "property/6737460151192632/019e1de9-77b6-70dd-b642-f690a80b105f.webp",
        "width": 1220,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Savannah/GA/Savannah/31419/122?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14182982413423792924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.9832439",
      "poi_longitude": "-81.1443152",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-921-0158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-988b-743d-aacb-7d161c0d6846",
        "storage_key": "property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2b1mw8B0-4gRHNO8P1wT1MQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fae69eb2-0d37-43ff-b380-656f593ba7b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Ace Convenience Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "11410 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-75c4-7226-aa4e-41a0939700f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-75c4-7226-aa4e-41a0939700f7",
        "storage_key": "property/6737460151192632/019e1de9-75c4-7226-aa4e-41a0939700f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2403551945336830218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ace-convenience-store",
      "poi_latitude": "31.9818962",
      "poi_longitude": "-81.14731150000001",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-219-3726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e09d-764f-98aa-fee986373796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e09d-764f-98aa-fee986373796",
        "storage_key": "property/6737460151192632/019e1de9-e09d-764f-98aa-fee986373796.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJkf8XnYd1-4gRCjkAfcIhWyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b7149f32-fdef-49fc-af66-b9cf7fbf1c79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "ABC beverages",
      "poi_type": "Shopping & Retail",
      "poi_address": "11420 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Liquor store in Varsity Park Shopping Center offering a good selection and chilled bottles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7bfd-745b-8414-49291b67394f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7bfd-745b-8414-49291b67394f",
        "storage_key": "property/6737460151192632/019e1de9-7bfd-745b-8414-49291b67394f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pointy.com/shops/usa/georgia/savannah/abc-beverages",
      "poi_directions_map_url": "https://maps.google.com/?cid=1880725513102353475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abc-beverages",
      "poi_latitude": "31.9820052",
      "poi_longitude": "-81.1475615",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-925-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-988b-743d-aacb-7d161c0d6846",
        "storage_key": "property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxyLM0sB0-4gRQ-R6wOOtGRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_b4657455-1f3a-4900-8d27-4e276f2b24dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "11509 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7afa-72bc-912f-fec3a1fdb00b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7afa-72bc-912f-fec3a1fdb00b",
        "storage_key": "property/6737460151192632/019e1de9-7afa-72bc-912f-fec3a1fdb00b.webp",
        "width": 1280,
        "height": 636
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11509+abercorn+st-savannah-ga-31419/id=5368",
      "poi_directions_map_url": "https://maps.google.com/?cid=6160899086943705190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "31.9812163",
      "poi_longitude": "-81.1494566",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-927-6119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwUlHsd0-4gRZthO5hPpf1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_38052e67-a609-4d74-b3ca-28e4fd2141b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Publix Super Market at Largo Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7899-77e4-82de-0ab776e5b4bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7899-77e4-82de-0ab776e5b4bb",
        "storage_key": "property/6737460151192632/019e1de9-7899-77e4-82de-0ab776e5b4bb.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1186&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342669933370170470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-largo-plaza",
      "poi_latitude": "31.9813532",
      "poi_longitude": "-81.15211",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-925-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-98cc-744e-b3c2-707a2cc92989.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-98cc-744e-b3c2-707a2cc92989",
        "storage_key": "property/6737460151192632/019e1de7-98cc-744e-b3c2-707a2cc92989.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVasScZ0-4gRZlwUErOwBVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9683ac42-2995-4dfe-acf6-a862b2b856d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Enmarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "14000 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7f9a-763b-8293-3366bb4c6810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7f9a-763b-8293-3366bb4c6810",
        "storage_key": "property/6737460151192632/019e1de9-7f9a-763b-8293-3366bb4c6810.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://enmarket.com/location/?store_id=010",
      "poi_directions_map_url": "https://maps.google.com/?cid=2926470594817314899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enmarket",
      "poi_latitude": "31.9806938",
      "poi_longitude": "-81.1695938",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-927-3430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e09d-764f-98aa-fee986373796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e09d-764f-98aa-fee986373796",
        "storage_key": "property/6737460151192632/019e1de9-e09d-764f-98aa-fee986373796.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJMy6MAzYL-4gRU1C2OYDpnCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_89556746-a016-41d2-a9a9-54aa874f105a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "14065 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-7f7d-739b-9b46-907668eea5dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-7f7d-739b-9b46-907668eea5dd",
        "storage_key": "property/6737460151192632/019e1de9-7f7d-739b-9b46-907668eea5dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/savannah/1910",
      "poi_directions_map_url": "https://maps.google.com/?cid=1239185135758866222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "31.98414069999999",
      "poi_longitude": "-81.1746917",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-925-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-988b-743d-aacb-7d161c0d6846",
        "storage_key": "property/6737460151192632/019e1de7-988b-743d-aacb-7d161c0d6846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7VON0DkL-4gRLvfZw1B4MhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_da3de4f3-984e-4ce8-ac02-f88ae35fb305",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Windsor Forest High School",
      "poi_type": "Education",
      "poi_address": "12419 Largo Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/wfhs/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17287387800476265407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsor-forest-high-school",
      "poi_latitude": "31.9764814",
      "poi_longitude": "-81.15294109999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-395-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ07kIXrh0-4gRvyvPrZwj6e8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_36631cee-2229-4e57-8139-a8bcadeb2663",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Windsor Forest Elementary School",
      "poi_type": "Education",
      "poi_address": "414 Briarcliff Cir, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18059267086944454536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsor-forest-elementary-school",
      "poi_latitude": "31.9747442",
      "poi_longitude": "-81.1447711",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-395-3353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc1z1Yr50-4gRiEc6xbtnn_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6cc285f7-401f-4006-b8c9-88284d1a2aff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Country Day School",
      "poi_type": "Education",
      "poi_address": "824 Stillwood Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-82d1-7236-83d2-cd5041d7569c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-82d1-7236-83d2-cd5041d7569c",
        "storage_key": "property/6737460151192632/019e1de9-82d1-7236-83d2-cd5041d7569c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.savcds.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374745490466152045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-country-day-school",
      "poi_latitude": "31.9687664",
      "poi_longitude": "-81.1430803",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-925-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrdlTr5d0-4gRbR7i59xafcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_44d026e3-80bb-429e-a85c-20dbfb21dd14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "White Bluff Elementary School",
      "poi_type": "Education",
      "poi_address": "9402 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5818570617262239194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-bluff-elementary-school",
      "poi_latitude": "31.990673",
      "poi_longitude": "-81.1271362",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-395-3325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNUYzNvp0-4gR2u1w9iW3v1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e384a0dc-58d9-4251-9938-a3b65ffb87fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Jacob G. Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "210 Lamara Dr, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://jgsmith.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5763647690796515271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacob-g-smith-elementary-school",
      "poi_latitude": "32.036422",
      "poi_longitude": "-81.1007209",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-395-6530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXdh5iox1-4gRxz9tpAmX_E8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dfc3ff31-a0b6-418d-80e5-9942b88928a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Tot's Learning Academy",
      "poi_type": "Education",
      "poi_address": "11710 Largo Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-88ef-707e-9d26-de0a7de7b78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-88ef-707e-9d26-de0a7de7b78d",
        "storage_key": "property/6737460151192632/019e1de9-88ef-707e-9d26-de0a7de7b78d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://families.decal.ga.gov/ChildCare/detail/38704",
      "poi_directions_map_url": "https://maps.google.com/?cid=15985612720242860175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tots-learning-academy",
      "poi_latitude": "31.9824226",
      "poi_longitude": "-81.1479147",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-441-2198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJERsqxcZ0-4gRj6AK2xJO2N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1d05a2ef-2b07-4198-a379-15e74c3a3e7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Tiny Tots Childcare Center",
      "poi_type": "Education",
      "poi_address": "145 Laurelwood Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-836d-7545-ab58-176403f720fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-836d-7545-ab58-176403f720fd",
        "storage_key": "property/6737460151192632/019e1de9-836d-7545-ab58-176403f720fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052097766013097367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiny-tots-childcare-center",
      "poi_latitude": "32.0282825",
      "poi_longitude": "-81.2434018",
      "poi_miles_from_property": "16",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-925-2933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK8Jz9yIK-4gRl1W17qg5gIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_82907aae-07b1-4bd9-ad30-f8358cf8bf20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Blossoms Adventure Learning Academy LLC",
      "poi_type": "Education",
      "poi_address": "99 Ristona Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-8700-74fb-aab9-71144ce381bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-8700-74fb-aab9-71144ce381bb",
        "storage_key": "property/6737460151192632/019e1de9-8700-74fb-aab9-71144ce381bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://blossomsala.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8195464888906649815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blossoms-adventure-learning-academy-llc",
      "poi_latitude": "31.9910608",
      "poi_longitude": "-81.2664985",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-417-2567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLdAteUAJ-4gR15B3IOUjvHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_86c88e85-c7e4-4d73-b348-08309f229eb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Dew Drop Inn",
      "poi_type": "Entertainment",
      "poi_address": "11432 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Unpretentious local watering hole offering karaoke and trivia nights, plus a good beer selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-8b64-759a-9c6e-ba57dd74869a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-8b64-759a-9c6e-ba57dd74869a",
        "storage_key": "property/6737460151192632/019e1de9-8b64-759a-9c6e-ba57dd74869a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dewdropinnsavannah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8790093641372441302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dew-drop-inn",
      "poi_latitude": "31.98206459999999",
      "poi_longitude": "-81.1477792",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-927-9757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e09f-700d-b44f-328d79ee6b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e09f-700d-b44f-328d79ee6b5b",
        "storage_key": "property/6737460151192632/019e1de9-e09f-700d-b44f-328d79ee6b5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbirLcd0-4gR1ppsTJiv_Hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "custom_5551eb7d-3994-49df-a83b-1fda2fc1e72d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "OAK 36 Bar + Kitchen",
      "poi_type": "Entertainment",
      "poi_address": "5500 Abercorn St Suite 36, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed eatery known for creative flatbreads, beer-battered wings, chicken and waffles, and fried green tomatoes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9311-72a9-acb9-4226bce7ed61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9311-72a9-acb9-4226bce7ed61",
        "storage_key": "property/6737460151192632/019e1de9-9311-72a9-acb9-4226bce7ed61.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://oakthirtysix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7820680775487158145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-36-bar--kitchen",
      "poi_latitude": "32.0231918",
      "poi_longitude": "-81.1087594",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-999-8112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9945-72be-86f2-46f4e5410f99",
        "storage_key": "property/6737460151192632/019e1de7-9945-72be-86f2-46f4e5410f99.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQZyWD91-4gRgXejxLqjiGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fb69a619-ab55-45e6-9427-e9bfeda58fdf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "The Wormhole Neighborhood Pub & Music Venue",
      "poi_type": "Entertainment",
      "poi_address": "2307 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Local haunt for live music & comedy shows, offering drink specials, late-night eats & billiards.",
      "poi_long_description": "Local haunt for live music & comedy shows, offering drink specials, late-night eats & billiards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-8c14-77fc-8107-d1d4f1a6151d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-8c14-77fc-8107-d1d4f1a6151d",
        "storage_key": "property/6737460151192632/019e1de9-8c14-77fc-8107-d1d4f1a6151d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wormholebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3952393816887604626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wormhole-neighborhood-pub--music-venue",
      "poi_latitude": "32.0552864",
      "poi_longitude": "-81.10134479999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-777-5720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e09f-700d-b44f-328d79ee6b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e09f-700d-b44f-328d79ee6b5b",
        "storage_key": "property/6737460151192632/019e1de9-e09f-700d-b44f-328d79ee6b5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaW5WxTye-4gRkjUJXDy52TY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_95766cc6-be81-45eb-a638-c1f34f5461ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Enmarket Arena",
      "poi_type": "Entertainment",
      "poi_address": "620 Stiles Ave, Savannah, GA 31415, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-8d8d-73a0-964c-84149d002312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-8d8d-73a0-964c-84149d002312",
        "storage_key": "property/6737460151192632/019e1de9-8d8d-73a0-964c-84149d002312.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.enmarketarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9620920495736123832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enmarket-arena",
      "poi_latitude": "32.0740493",
      "poi_longitude": "-81.11158069999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-468-5177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzQLsxKf-4gRuHGgkDdghIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a336c26e-8edb-4387-8203-a06cc025ef3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Theatre",
      "poi_type": "Entertainment",
      "poi_address": "222 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_long_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-919c-737f-9fb8-1ffde5776c9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-919c-737f-9fb8-1ffde5776c9d",
        "storage_key": "property/6737460151192632/019e1de9-919c-737f-9fb8-1ffde5776c9d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12411390908795783721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-theatre",
      "poi_latitude": "32.0758167",
      "poi_longitude": "-81.0924435",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-233-7764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTqMrmie-4gRKQpJ70UePqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e4cc338b-f4a0-474b-a544-3ada851c286f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Jepson Center & Telfair Children's Art Museum (CAM)",
      "poi_type": "Entertainment",
      "poi_address": "207 W York St, Savannah, GA 31401, USA",
      "poi_short_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_long_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9309-762c-b495-4ca0efc130b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9309-762c-b495-4ca0efc130b6",
        "storage_key": "property/6737460151192632/019e1de9-9309-762c-b495-4ca0efc130b6.webp",
        "width": 1280,
        "height": 1001
      },
      "poi_business_url": "http://www.telfair.org/visit/jepson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733686102627315117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jepson-center--telfair-childrens-art-museum-cam",
      "poi_latitude": "32.0782855",
      "poi_longitude": "-81.0951522",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992f-776f-83cc-367fca8f6ded",
        "storage_key": "property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRre39-dn-Oeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_9ed1f710-1ad4-4960-8485-4c9096d88530",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_long_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9148-701c-87b0-a2d418954ced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9148-701c-87b0-a2d418954ced",
        "storage_key": "property/6737460151192632/019e1de9-9148-701c-87b0-a2d418954ced.webp",
        "width": 827,
        "height": 1240
      },
      "poi_business_url": "http://www.chsgeorgia.org/SCM",
      "poi_directions_map_url": "https://maps.google.com/?cid=606148658374513045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-childrens-museum",
      "poi_latitude": "32.0760234",
      "poi_longitude": "-81.10093359999999",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992f-776f-83cc-367fca8f6ded",
        "storage_key": "property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RuwSlue-4gRlRF-R_54aQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_180edaa5-a5aa-4999-b2bd-2ccd76dde628",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Oatland Island Wildlife Center",
      "poi_type": "Entertainment",
      "poi_address": "711 Sandtown Rd, Savannah, GA 31410, USA",
      "poi_short_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_long_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a010-769a-a88e-1c8b18fa488e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a010-769a-a88e-1c8b18fa488e",
        "storage_key": "property/6737460151192632/019e1de9-a010-769a-a88e-1c8b18fa488e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oatland.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055131803854154654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oatland-island-wildlife-center",
      "poi_latitude": "32.049159",
      "poi_longitude": "-81.02449969999999",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-395-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKz5cUG6d-4gRnqs9OYFuTKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_park"
    },
    {
      "id": "custom_e783c7e4-def6-49bc-86eb-b8a62d125293",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Wormsloe State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "7601 Skidaway Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_long_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-3041-76bf-a586-55d6162a106b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-3041-76bf-a586-55d6162a106b",
        "storage_key": "property/6737460151192632/019e1de7-3041-76bf-a586-55d6162a106b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gastateparks.org/Wormsloe",
      "poi_directions_map_url": "https://maps.google.com/?cid=10012291246731543177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wormsloe-state-historic-site",
      "poi_latitude": "31.9801601",
      "poi_longitude": "-81.0692663",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-353-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992f-776f-83cc-367fca8f6ded",
        "storage_key": "property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Ccw5x2-4gRicIvbdfN8oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c5449daa-4da7-46fa-9527-c4a1dde72531",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "AMC CLASSIC Savannah 11",
      "poi_type": "Entertainment",
      "poi_address": "1150 Shawnee St, Savannah, GA 31420, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-99ae-741c-ac5f-824443f8a944.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-99ae-741c-ac5f-824443f8a944",
        "storage_key": "property/6737460151192632/019e1de9-99ae-741c-ac5f-824443f8a944.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/savannah-ga/amc-classic-savannah-11?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4847953490304313417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-savannah-11",
      "poi_latitude": "31.9869643",
      "poi_longitude": "-81.17182729999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-920-3994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e0ea-73fb-8ee5-25262fab071e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e0ea-73fb-8ee5-25262fab071e",
        "storage_key": "property/6737460151192632/019e1de9-e0ea-73fb-8ee5-25262fab071e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4m4LjcL-4gRSSg0jQNkR0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a581a98e-1d18-4d57-80d8-468810086cd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Immediate Med",
      "poi_type": "Health and Wellness",
      "poi_address": "10410 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9cf7-7789-9ca2-cb96189c7e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9cf7-7789-9ca2-cb96189c7e03",
        "storage_key": "property/6737460151192632/019e1de9-9cf7-7789-9ca2-cb96189c7e03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.immediatemed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6861350260721187192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "immediate-med",
      "poi_latitude": "31.9871884",
      "poi_longitude": "-81.131028",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 912-927-6832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q1J--90-4gRePnRibVpOF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_950c95e2-dd11-47d0-a24e-544ee764e8bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "ExperCARE Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "318 Mall Blvd Suite 300B, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9a1e-72e8-9547-225c7a8bd476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9a1e-72e8-9547-225c7a8bd476",
        "storage_key": "property/6737460151192632/019e1de9-9a1e-72e8-9547-225c7a8bd476.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://expercarehealth.com/locations/mall-bvld/?utm_source=google+business+profile&utm_medium=organic&utm_campaign=gbp&utm_content=mall-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=13610162031091346078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expercare-urgent-care--primary-care",
      "poi_latitude": "32.0056323",
      "poi_longitude": "-81.1113836",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-358-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3W9jK51-4gRnmq17kEC4bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6093dce9-c2fd-4549-9f4a-c83a0e50f727",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Southside",
      "poi_type": "Health and Wellness",
      "poi_address": "14089 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9c21-738e-b5d6-fa4a8cdd2b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9c21-738e-b5d6-fa4a8cdd2b3e",
        "storage_key": "property/6737460151192632/019e1de9-9c21-738e-b5d6-fa4a8cdd2b3e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.carenow.com/locations/savannah/southside?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11370330533149396854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---southside",
      "poi_latitude": "31.9829965",
      "poi_longitude": "-81.1758766",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-777-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXUcNzgL-4gRds8ll2CHy50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_466fb86a-3f56-469e-84ff-f219c1c47c12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14030 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-98f6-738f-b5e7-402168532dfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-98f6-738f-b5e7-402168532dfe",
        "storage_key": "property/6737460151192632/019e1de9-98f6-738f-b5e7-402168532dfe.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4556-savannah-ga/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=387970644702086086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "31.9808092",
      "poi_longitude": "-81.17354399999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-344-9671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e0c9-70d9-983d-55cecb38c26d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e0c9-70d9-983d-55cecb38c26d",
        "storage_key": "property/6737460151192632/019e1de9-e0c9-70d9-983d-55cecb38c26d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7Zt5DcL-4gRxkO_7D5ZYgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_959e3692-3bb6-4204-a74a-0f0fc50b8300",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14065 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-99c0-753f-a28f-c72a63ea1420.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-99c0-753f-a28f-c72a63ea1420",
        "storage_key": "property/6737460151192632/019e1de9-99c0-753f-a28f-c72a63ea1420.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/savannah-ga-pharmacies/14065-abercorn-st-savannah-ga-31419/storeid=17028?WT.mc_id=LS_GOOGLE_RX_17028",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282384669187776312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "31.9844445",
      "poi_longitude": "-81.17463959999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-925-2918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e0c9-70d9-983d-55cecb38c26d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e0c9-70d9-983d-55cecb38c26d",
        "storage_key": "property/6737460151192632/019e1de9-e0c9-70d9-983d-55cecb38c26d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VON0DkL-4gROB_ojd7MTkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2dfcc78b-754a-42ef-accb-360546228729",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "The ZOO Health Club Savannah",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Mall Way, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9c81-747a-9c3c-e4e8f40fe4cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9c81-747a-9c3c-e4e8f40fe4cb",
        "storage_key": "property/6737460151192632/019e1de9-9c81-747a-9c3c-e4e8f40fe4cb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.zoogymsavannah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6512998031151290498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-zoo-health-club-savannah",
      "poi_latitude": "32.0015318",
      "poi_longitude": "-81.1138755",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-712-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1WVyzx1-4gRgliXtTPRYlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ab00c07c-14d7-497d-ae99-1d6f4b83991a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "StretchLab",
      "poi_type": "Health and Wellness",
      "poi_address": "5525 Abercorn St Suite #90, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed, clean studio for one-on-one and group stretching services, plus demos and packages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-9f85-76cb-8535-19ca48dedaab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-9f85-76cb-8535-19ca48dedaab",
        "storage_key": "property/6737460151192632/019e1de9-9f85-76cb-8535-19ca48dedaab.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://local.stretchlab.com/location/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828985834247785036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stretchlab",
      "poi_latitude": "32.0241435",
      "poi_longitude": "-81.11211159999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-335-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRShW8p1-4gRTIqPBe3cYRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5c74050c-795c-4746-ab5f-c6a86a8f8bbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "5521 Abercorn St Suite 500, Savannah, GA 31406, USA",
      "poi_short_description": "Ballet-inspired fitness center focusing on low-impact, high-intensity exercises for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a142-7329-b4f2-8242a4e95b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a142-7329-b4f2-8242a4e95b3d",
        "storage_key": "property/6737460151192632/019e1de9-a142-7329-b4f2-8242a4e95b3d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/savannah-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=2331048834905319645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.0248728",
      "poi_longitude": "-81.1103564",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-665-1129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-GpxZl1-4gR3aienpCMWSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_42c9b5b1-7daf-482e-89b9-f15cf3bcf8b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Joseph Tribble Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12517 Largo Dr, Savannah, GA 31419, USA",
      "poi_short_description": "Peaceful, dog-friendly park featuring a playground, picnic area, pond and trails for jogging and walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a769-73b0-a74e-9a66f58b20a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a769-73b0-a74e-9a66f58b20a3",
        "storage_key": "property/6737460151192632/019e1de9-a769-73b0-a74e-9a66f58b20a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahga.gov/index.aspx?NID=351",
      "poi_directions_map_url": "https://maps.google.com/?cid=12182625584448583248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-tribble-park",
      "poi_latitude": "31.96891249999999",
      "poi_longitude": "-81.15563809999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTmwDLB0-4gRULakOGxhEak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_02abf462-d656-45f5-aa29-42014985caa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "L Scott Stell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "195 Scott Stell Park, Savannah, GA 31419, USA",
      "poi_short_description": "Easygoing, lakefront space with a boat launch, walking trails & covered picnic facilities.",
      "poi_long_description": "Easygoing, lakefront space with a boat launch, walking trails & covered picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a49a-76b1-8dda-dc0bcc1816c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a49a-76b1-8dda-dc0bcc1816c0",
        "storage_key": "property/6737460151192632/019e1de9-a49a-76b1-8dda-dc0bcc1816c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=568174053801707977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "l-scott-stell-park",
      "poi_latitude": "32.0386394",
      "poi_longitude": "-81.2854385",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-436-6531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UIqNzMI-4gRyclxp0qP4gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_059f3283-23c7-4648-9c0e-cfefd0396ca6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Mohawk Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1134 Mohawk St, Savannah, GA 31419, USA",
      "poi_short_description": "Community park for big and small pups featuring grassy areas and a lake amid scenic surrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a885-723d-9ee1-b4a240a0df63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a885-723d-9ee1-b4a240a0df63",
        "storage_key": "property/6737460151192632/019e1de9-a885-723d-9ee1-b4a240a0df63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10578989518803625640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mohawk-dog-park",
      "poi_latitude": "31.99274239999999",
      "poi_longitude": "-81.1687963",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dJNLTwL-4gRqObe3uoe0JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_e9c8edc2-6853-4b06-a803-6f2f7b41ec4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Lake Mayer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1850 E Montgomery Cross Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Park with a lake offering picnic areas, a playground, tennis courts, and a skateboarding area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-6feb-743b-a2a1-93a217ab5543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-6feb-743b-a2a1-93a217ab5543",
        "storage_key": "property/6737460151192632/019e1de7-6feb-743b-a2a1-93a217ab5543.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/LakeMayer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999149330770112106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mayer-park",
      "poi_latitude": "31.992331",
      "poi_longitude": "-81.08626799999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSN4wkl1-4gRai6Dcblnvhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_630a76ca-47cb-4bae-a84e-ddf3bee5ab50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Daffin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E Victory Dr, Savannah, GA 31404, USA",
      "poi_short_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_long_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-88d6-73c9-9899-c0b5d7246af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-88d6-73c9-9899-c0b5d7246af3",
        "storage_key": "property/6737460151192632/019e1de7-88d6-73c9-9899-c0b5d7246af3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/2957/Recreation-and-Leisure-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=10299007936776474142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daffin-park",
      "poi_latitude": "32.045328",
      "poi_longitude": "-81.0815665",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeNjUQCe-4gRHo596iZt7Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c684bee0-2826-4216-9bee-5e4663997051",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Ogeechee Canal Museum and Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "681 Fort Argyle Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_long_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-ac2b-70ce-bc78-1ef96873e2e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-ac2b-70ce-bc78-1ef96873e2e2",
        "storage_key": "property/6737460151192632/019e1de9-ac2b-70ce-bc78-1ef96873e2e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahogeecheecanal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306472962369169396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-ogeechee-canal-museum-and-nature-center",
      "poi_latitude": "32.0231191",
      "poi_longitude": "-81.3167919",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-748-8068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992f-776f-83cc-367fca8f6ded",
        "storage_key": "property/6737460151192632/019e1de7-992f-776f-83cc-367fca8f6ded.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXT4FV0I-4gR9KdyDaTz4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ce2bb240-35a7-4dc5-8bcc-092762e3eb04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Coastal Georgia Botanical Gardens at the Historic Bamboo Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 Canebrake Rd, Savannah, GA 31419, USA",
      "poi_short_description": "This 51-acre horticultural attraction boasts ornamental gardens & pick-your-own berry fields.",
      "poi_long_description": "This 51-acre horticultural attraction boasts ornamental gardens & pick-your-own berry fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-a821-754f-9a22-66ce5fc867c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-a821-754f-9a22-66ce5fc867c5",
        "storage_key": "property/6737460151192632/019e1de9-a821-754f-9a22-66ce5fc867c5.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://coastalbg.uga.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1202429024759441435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-georgia-botanical-gardens-at-the-historic-bamboo-farm",
      "poi_latitude": "31.99848",
      "poi_longitude": "-81.26985800000001",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-921-5460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC7t-y20J-4gRG-hnyNPirxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_f0de223a-be89-41a1-b816-c1e86912168f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Al Bungard Conservation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Chief Of Love Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Park on a small lake featuring picnic tables and a pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b37f-7440-8af8-38209239e1af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b37f-7440-8af8-38209239e1af",
        "storage_key": "property/6737460151192632/019e1de9-b37f-7440-8af8-38209239e1af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/NaturePreserves/BungardConservationArea",
      "poi_directions_map_url": "https://maps.google.com/?cid=4893777153824965471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "al-bungard-conservation-area",
      "poi_latitude": "31.9871373",
      "poi_longitude": "-81.286228",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVILpBoJ-4gRX8Oon2Qw6kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_dbafa0fb-92fe-47ae-afd5-c698a2d19d5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Kings Ferry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6820 Chief Of Love Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Tranquil park along the Ogeechee River, with a boat ramp and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b052-7109-9057-4fcfcfa62a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b052-7109-9057-4fcfcfa62a10",
        "storage_key": "property/6737460151192632/019e1de9-b052-7109-9057-4fcfcfa62a10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://parks.chathamcounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4262276922834071583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-ferry",
      "poi_latitude": "31.9785709",
      "poi_longitude": "-81.28783419999999",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPaj9DCUJ-4gRH7DeX0emJjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38519d04-cde3-4e36-9d75-77ec7033d403",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Skidaway Island State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "52 Diamond Causeway, Savannah, GA 31411, USA",
      "poi_short_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_long_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-63b3-7479-b07a-ca20a223316b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-63b3-7479-b07a-ca20a223316b",
        "storage_key": "property/6737460151192632/019e1de7-63b3-7479-b07a-ca20a223316b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gastateparks.org/SkidawayIsland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471744632454584550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skidaway-island-state-park",
      "poi_latitude": "31.95476559999999",
      "poi_longitude": "-81.0525755",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-598-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9947-738d-94b9-bacdb42e611b",
        "storage_key": "property/6737460151192632/019e1de7-9947-738d-94b9-bacdb42e611b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TuGrZ2-4gR5hhn4Hhkl-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_30b87378-d918-4657-ae1c-5b25be25e89f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Joe Murray Rivers, Jr. Intermodal Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-ac8d-7107-a549-2f7b6ad91665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-ac8d-7107-a549-2f7b6ad91665",
        "storage_key": "property/6737460151192632/019e1de9-ac8d-7107-a549-2f7b6ad91665.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901387300494243883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-murray-rivers-jr-intermodal-transit-center",
      "poi_latitude": "32.0795155",
      "poi_longitude": "-81.0998743",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e0f2-7764-b13a-663468bca340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e0f2-7764-b13a-663468bca340",
        "storage_key": "property/6737460151192632/019e1de9-e0f2-7764-b13a-663468bca340.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6fx-Fye-4gRK_i97uJdp20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_5a93aa2f-d6fc-4f40-8613-59de7345789d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Chatham Area Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 E Gwinnett St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-adc2-7136-bc3c-81ef3de7de70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-adc2-7136-bc3c-81ef3de7de70",
        "storage_key": "property/6737460151192632/019e1de9-adc2-7136-bc3c-81ef3de7de70.webp",
        "width": 1073,
        "height": 1121
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14211752328539634895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chatham-area-transit",
      "poi_latitude": "32.0637541",
      "poi_longitude": "-81.0813304",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQLY82Se-4gRz3xvGnJJOsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_62bdbb28-8617-4d7c-953c-6c2edeecc127",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Chatham Area Transit Authority (CAT)",
      "poi_type": "Transportation & Transit",
      "poi_address": "610 W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b1eb-75ea-933e-4a631c25b132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b1eb-75ea-933e-4a631c25b132",
        "storage_key": "property/6737460151192632/019e1de9-b1eb-75ea-933e-4a631c25b132.webp",
        "width": 800,
        "height": 549
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7892773447189232483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chatham-area-transit-authority-cat",
      "poi_latitude": "32.0792723",
      "poi_longitude": "-81.1001088",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-CJxwye-4gRY3tZ7KHDiG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c3420a9e-9de6-4af9-a180-d3aa63cb8878",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "CAT Bike",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 W Congress St Ste 218, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b3df-767a-965e-b7789b90058b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b3df-767a-965e-b7789b90058b",
        "storage_key": "property/6737460151192632/019e1de9-b3df-767a-965e-b7789b90058b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11993237553048775141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cat-bike",
      "poi_latitude": "32.0803713",
      "poi_longitude": "-81.09419129999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7rD5Wae-4gR5elY-AKKcKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_62f8ea51-097d-4c54-a183-481303e2be18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah",
      "poi_type": "Transportation & Transit",
      "poi_address": "2611 Seaboard Coastline Dr, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b37e-7048-afac-14ded8299b14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b37e-7048-afac-14ded8299b14",
        "storage_key": "property/6737460151192632/019e1de9-b37e-7048-afac-14ded8299b14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SAV",
      "poi_directions_map_url": "https://maps.google.com/?cid=1136550232795717085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah",
      "poi_latitude": "32.083701",
      "poi_longitude": "-81.1485479",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e09d-764f-98aa-fbf54f598ad2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e09d-764f-98aa-fbf54f598ad2",
        "storage_key": "property/6737460151192632/019e1de9-e09d-764f-98aa-fbf54f598ad2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbNe15mf-4gR3R0tP2rWxQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a7f27e47-e1d0-4e1a-a177-a964f2c6212b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "City Hall Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "River Walk at City Hall, E Upper Factors Walk, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-ba48-71e4-81cd-aeda7a69759e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-ba48-71e4-81cd-aeda7a69759e",
        "storage_key": "property/6737460151192632/019e1de9-ba48-71e4-81cd-aeda7a69759e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.connectonthedot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12544589026507261472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-hall-landing",
      "poi_latitude": "32.0817928",
      "poi_longitude": "-81.09077049999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQRPCmSe-4gRIIY6akFVF64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_terminal"
    },
    {
      "id": "custom_b44b64d0-2045-4fe2-a79a-4aacb39ed1eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Belles Ferry Stop, Trade Center Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "4032 International Dr, Savannah, GA 31402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b914-71e6-948e-df07ae489b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b914-71e6-948e-df07ae489b22",
        "storage_key": "property/6737460151192632/019e1de9-b914-71e6-948e-df07ae489b22.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.catchacat.org/getting-around/ride-free-downtown/savannah-belles-ferry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12317820752603385558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-belles-ferry-stop-trade-center-landing",
      "poi_latitude": "32.0833485",
      "poi_longitude": "-81.0863542",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wcFy3ye-4gR1g7cPbaw8ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "custom_f1d1d2d6-b4fe-4460-b1c9-615da3427d5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-4171-7030-8732-d3fd37227e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-4171-7030-8732-d3fd37227e98",
        "storage_key": "property/6737460151192632/019e1de7-4171-7030-8732-d3fd37227e98.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-98cc-744e-b3c2-75973c4c0b44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-98cc-744e-b3c2-75973c4c0b44",
        "storage_key": "property/6737460151192632/019e1de7-98cc-744e-b3c2-75973c4c0b44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_dcbb4156-763c-42e9-b80b-ea952b9e2989",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Candler Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5353 Reynolds St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-603e-763f-a1b0-ca53aa7641ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-603e-763f-a1b0-ca53aa7641ad",
        "storage_key": "property/6737460151192632/019e1de7-603e-763f-a1b0-ca53aa7641ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sjchs.org/locations/locationdetails/candler-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058112974386619187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "candler-hospital",
      "poi_latitude": "32.0281014",
      "poi_longitude": "-81.1003141",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-819-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-98cc-744e-b3c2-75973c4c0b44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-98cc-744e-b3c2-75973c4c0b44",
        "storage_key": "property/6737460151192632/019e1de7-98cc-744e-b3c2-75973c4c0b44.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb2fD5N1-4gRM-PXE90FV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f4f9efcd-6f30-4400-a8b7-adeb6d631370",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-b900-7528-9d22-ab2a528fbe07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-b900-7528-9d22-ab2a528fbe07",
        "storage_key": "property/6737460151192632/019e1de9-b900-7528-9d22-ab2a528fbe07.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "17.1",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_6ad73dd2-0157-45aa-91de-c5238e7c3cbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-baa9-77af-a0dd-f2eee8426f19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-baa9-77af-a0dd-f2eee8426f19",
        "storage_key": "property/6737460151192632/019e1de9-baa9-77af-a0dd-f2eee8426f19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-992c-752e-bdd7-257ceca290b6",
        "storage_key": "property/6737460151192632/019e1de7-992c-752e-bdd7-257ceca290b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5bca7e0a-cdd6-427f-8af2-b6bcb2cc6105",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-d540-7420-9c79-ac45ac92a7ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-d540-7420-9c79-ac45ac92a7ec",
        "storage_key": "property/6737460151192632/019e1de9-d540-7420-9c79-ac45ac92a7ec.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "16.7",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9cda-76ec-b471-dd7ac8b23c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9cda-76ec-b471-dd7ac8b23c3e",
        "storage_key": "property/6737460151192632/019e1de7-9cda-76ec-b471-dd7ac8b23c3e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_68d75eeb-2e92-49fd-afc6-49060a4404b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Hunter Army Airfield Deers, AWS, and more",
      "poi_type": "Major Employers & Offices",
      "poi_address": "171 Haley Ave, Savannah, GA 31409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://home.army.mil/stewart/about/Garrison/DHR/MPD/id-cards-deers",
      "poi_directions_map_url": "https://maps.google.com/?cid=12070937004809537966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hunter-army-airfield-deers-aws-and-more",
      "poi_latitude": "32.0241332",
      "poi_longitude": "-81.1267738",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-315-5726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-e0f2-7764-b13a-68d04146214d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de9-e0f2-7764-b13a-68d04146214d",
        "storage_key": "property/6737460151192632/019e1de9-e0f2-7764-b13a-68d04146214d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWZvDZ3k-ogRrknKVUCVhKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afe2fe41-d662-4e1d-b64d-25b43b2cd14b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Georgia Southern University Armstrong Campus Savannah",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11935 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-2d88-77fb-b391-ad0c73247eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-2d88-77fb-b391-ad0c73247eab",
        "storage_key": "property/6737460151192632/019e1de7-2d88-77fb-b391-ad0c73247eab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/armstrong-campus-savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=783516353767565760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-armstrong-campus-savannah",
      "poi_latitude": "31.9786073",
      "poi_longitude": "-81.1634639",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9h8y0oL-4gRwGkG9vib3wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1a8fe419-159b-44e8-9361-81cbcd941e56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah College of Art and Design",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Drayton St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de9-bc80-7300-9fe9-c41f355d7398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de9-bc80-7300-9fe9-c41f355d7398",
        "storage_key": "property/6737460151192632/019e1de9-bc80-7300-9fe9-c41f355d7398.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.scad.edu/locations/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151614706338739018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-college-of-art-and-design",
      "poi_latitude": "32.0691097",
      "poi_longitude": "-81.0938141",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-525-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUzHD2me-4gRSrMTb2d95_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_41ae3d3c-0163-4905-9a4f-820c78b56be9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3219 College St, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-28d1-7733-ac51-90f2f8d5038f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-28d1-7733-ac51-90f2f8d5038f",
        "storage_key": "property/6737460151192632/019e1de7-28d1-7733-ac51-90f2f8d5038f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://savannahstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=170532476337488424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-state-university",
      "poi_latitude": "32.0241968",
      "poi_longitude": "-81.0625787",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-358-4162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5BqurZ3-4gRKILDOmLaXQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_65549ddf-c90b-4f2e-9095-91165df78f74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "custom",
      "poi_name": "Savannah Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5717 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-2ac1-76cd-8823-5a422034d56c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de7-2ac1-76cd-8823-5a422034d56c",
        "storage_key": "property/6737460151192632/019e1de7-2ac1-76cd-8823-5a422034d56c.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "https://www.savannahtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7052498624589095008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-technical-college",
      "poi_latitude": "32.0235786",
      "poi_longitude": "-81.1141815",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-443-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de7-9930-77b9-8b8e-7722604c21d6",
        "storage_key": "property/6737460151192632/019e1de7-9930-77b9-8b8e-7722604c21d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdS0rI591-4gRYGCQISKC32E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "custom_47e3088a-f85b-4541-92d4-2b37129cfbbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ff284946-ecfe-4101-880a-d3a4ff3c03ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e95ad4c5-628f-4975-b410-1f2eaeff4057",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_24821ea2-ac9a-4c01-9775-ad68d63ad296",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3de4c5e6-9857-4131-ab54-29eea1e34e44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_87ae9cbe-df5c-4c3b-b81c-505616a3246f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_fa637c9b-bd1e-43f8-86fb-e46a72c70025",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "rating": "5",
      "name": "Clara Jordan",
      "text": "Sarah is incredibly helpful, she's by far the best property manager I've ever had, and very clearly cares about people!",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_13684d92-f740-4e76-953b-79fec3a2aabc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "rating": "5",
      "name": "Ezra Hoffman",
      "text": "Sarah was so helpful and gave me and my partner a very good feel for the complex! She was lovely to speak with and gave us all the information we needed.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_68bdd650-3ddd-4772-8244-0cc5b470998f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "rating": "5",
      "name": "Mariya Jefferson",
      "text": "The tour was very respectful and thorough. I loved the place and hope to move in soon!",
      "date": "2026-03-27",
      "title": "false"
    },
    {
      "id": "custom_743d848c-01bc-428f-bb1f-607a80980c29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "rating": "5",
      "name": "Saylorea Johnson-Love",
      "text": "Miss Sarah was so sweet and very kind. Gave a really good and informative tour. Really enjoyed my time.",
      "date": "2026-03-27",
      "title": "false"
    },
    {
      "id": "custom_0b607b7d-0f28-4459-beac-1fcffb1fd4f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "rating": "5",
      "name": "Keiya Wilson",
      "text": "Ms.Sarah.was pleasant and informative..thank you",
      "date": "2026-03-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_874c948b1bf8d461234bbe75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-bbb7-767d-bf5b-4f7d827f57d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, sink, and dishwasher.",
        "public_id": "019d0784-bbb7-767d-bf5b-4f7d827f57d7",
        "storage_key": "property/6737460151192632/019d0784-bbb7-767d-bf5b-4f7d827f57d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 744 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NCmhiPjkUs9"
    },
    {
      "id": "ec_f9af071ade7ccd3a737644c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-bae4-73b4-b882-d4003db235ff.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white appliances, cabinets, and dark wood floors.",
        "public_id": "019d0784-bae4-73b4-b882-d4003db235ff",
        "storage_key": "property/6737460151192632/019d0784-bae4-73b4-b882-d4003db235ff.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 1BA - 830 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8ujnr1F48mb"
    },
    {
      "id": "ec_5178ecbb6b8036ab4a601c62",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-0d3e-75f9-ac5c-51b7cc55ae5d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and a sliding glass door.",
        "public_id": "019d0784-0d3e-75f9-ac5c-51b7cc55ae5d",
        "storage_key": "property/6737460151192632/019d0784-0d3e-75f9-ac5c-51b7cc55ae5d.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "3BR, 1BA - 1050 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bUt6qYAjrM6"
    },
    {
      "id": "ec_227225c858216c127a8f4dbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-198b-743c-9acb-8bab607a455f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, and artwork.",
        "public_id": "019d0784-198b-743c-9acb-8bab607a455f",
        "storage_key": "property/6737460151192632/019d0784-198b-743c-9acb-8bab607a455f.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BD, 1BA - 830SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K1KMq7796xj"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993ac7-2975-715b-810a-88c567a76a94",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-ascend-at-savannah-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632"
    },
    {
      "lead_collector_id": "019a5022-080b-76c0-bc1c-336a73fb26a0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-ascend-at-savannah-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-savannah-ga",
      "search_query": "fitness center apartments savannah ga",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Savannah, GA",
      "h2_subtitle": "Experience top-notch living with our fitness center apartments. Ascend at Savannah offers prime amenities just for you in GA.",
      "page_copy": "At Ascend at Savannah, elevate your lifestyle by choosing our fitness center apartments in the heart of Savannah, GA. Perfectly situated in Chatham County's Windsor Forest, our apartments provide not just a place to live, but a community enriched with a quality fitness center right on site. Whether you're enjoying a morning workout or unwinding after a long day, our gym is always open and equipped to meet your needs.\n\nOur residents enjoy more than just a state-of-the-art fitness center. With one, two, and three-bedroom apartment options, Ascend at Savannah is committed to providing homes that combine comfort and convenience. Explore our extensive amenities, including a playground, clubhouse, and sports courts. Come discover the active lifestyle waiting for you at Ascend!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Savannah, GA",
      "seo_description": "Discover fitness center apartments in Savannah, GA. Ascend at Savannah offers modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "walk-in-closets-savannah-apartment-rentals",
      "search_query": "walk-in closets savannah apartment rentals",
      "category": "Amenity",
      "h1_title": "Savannah Apartments with Walk-In Closets",
      "h2_subtitle": "Explore Savannah apartment rentals featuring spacious walk-in closets. Find your ideal home at Ascend at Savannah.",
      "page_copy": "Discover the luxury of ample storage space with our Savannah apartment rentals featuring walk-in closets at Ascend at Savannah. Nestled in the inviting neighborhood of Windsor Forest, our community offers apartments that are designed with your needs in mind. Whether you choose a one, two, or three-bedroom layout, you'll enjoy the convenience of extra storage in your spacious walk-in closet.\n\nBeyond generous closet space, Ascend at Savannah provides a host of amenities to enhance your lifestyle. From our modern fitness center and security system to playgrounds and sports courts, our community ensures both comfort and convenience. Plus, with laundry facilities and a car wash area onsite, everything you need is right at your fingertips. Experience elevated living in Savannah today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah Apartments with Walk-In Closets",
      "seo_description": "Find Savannah apartment rentals with walk-in closets at Ascend. Explore spacious homes and convenient amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-chatham-county",
      "search_query": "family-friendly apartments chatham county",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments in Chatham County",
      "h2_subtitle": "Welcome to Ascend at Savannah, your premier choice for family-friendly apartments in Chatham County. Enjoy amenities tailored for every family.",
      "page_copy": "Ascend at Savannah is your destination for family-friendly apartments in Chatham County. Conveniently located in Windsor Forest, our community is tailored to meet the needs of families seeking comfort and convenience. Our one, two, and three-bedroom apartments offer the perfect space for families of all sizes, each home thoughtfully designed with features that make everyday living a breeze.\n\nOur amenities are crafted to ensure a welcoming environment where families can thrive. Kids will love spending time at our playground, while adults appreciate facilities like a fitness center and clubhouse. With 24-hour access, a security system, and walk-up designs, Ascend at Savannah offers the peace of mind and fun that every family deserves. Discover a home where family moments are made every day!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments in Chatham County",
      "seo_description": "Find family-friendly apartments in Chatham County at Ascend. Discover great amenities and spacious living spaces perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-windsor-forest",
      "search_query": "smoke-free apartments windsor forest",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Windsor Forest",
      "h2_subtitle": "Enjoy the benefits of a smoke-free community at Ascend at Savannah. Ideal smoke-free living in Windsor Forest awaits you.",
      "page_copy": "Experience a healthier lifestyle with our smoke-free apartments at Ascend at Savannah, located in the charming neighborhood of Windsor Forest. Our community prioritizes the well-being of residents by maintaining a clean and smoke-free environment throughout our property. Choose from our range of spacious one, two, or three-bedroom apartment options, all designed for modern living.\n\nBeing smoke-free is just one of the many advantages of residing at Ascend. Residents also have access to superb amenities such as a fitness center, clubhouse, and sports courts. Your family can enjoy the freedom of smoke-free outdoor spaces, including our playground and communal areas. Embrace the comfort of a smoke-free lifestyle at Ascend at Savannah, where quality living is our promise.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Windsor Forest",
      "seo_description": "Ascend at Savannah offers smoke-free apartments in Windsor Forest. Enjoy a healthy lifestyle in a great location with amenities for all.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "air-conditioned-units-savannah-ascension",
      "search_query": "air conditioned units savannah ascension",
      "category": "Amenity",
      "h1_title": "Savannah Ascend's Air Conditioned Units",
      "h2_subtitle": "Stay cool with air-conditioned units at Ascend at Savannah. Discover comfort in the heart of Savannah today.",
      "page_copy": "Beat the Georgia heat by choosing air-conditioned units at Ascend at Savannah. Located in the Windsor Forest neighborhood, our modern apartments ensure you stay cool and comfortable throughout the year. Whether you're relaxing at home or entertaining guests, our efficient air conditioning provides relief and comfort in every apartment.\n\nChoose from a variety of floor plans, including one, two, or three-bedroom options, all enhanced with premium amenities. The community at Ascend offers more than just cool comfort; enjoy our fitness center, clubhouse, and sports courts too. With security systems and walk-up designs, our community blends comfort with convenience, making it an ideal place to call home in Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah Ascend's Air Conditioned Units",
      "seo_description": "Find air conditioned units at Ascend in Savannah. Comfortable living with modern amenities awaits you in Windsor Forest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-savannah-ga",
      "search_query": "1 bedroom apartments savannah ga",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Savannah, GA",
      "h2_subtitle": "Discover your perfect 1 bedroom apartment at Ascend at Savannah. Experience living amid the charm of Savannah, GA.",
      "page_copy": "Ascend at Savannah invites you to explore our range of stylish 1 bedroom apartments in Savannah, GA. Ideally located in the vibrant Windsor Forest area, our apartments offer an ideal balance of comfort and convenience. Each unit is thoughtfully designed with modern features, including an efficient air conditioning system, ensuring a cozy retreat from the bustling city life.\n\nOur community extends beyond just the apartment doors, offering residents access to premium amenities such as a state-of-the-art fitness center, a welcoming clubhouse, and conveniently equipped laundry facilities. With a strong sense of community and easy access to local attractions, Ascend at Savannah's 1 bedroom apartments provide the quintessential Savannah living experience. Discover your new home today at Ascend at Savannah!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Savannah, GA",
      "seo_description": "Find stylish 1 bedroom apartments in Savannah, GA at Ascend. Enjoy modern amenities and community living in Windsor Forest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-windsor-forest",
      "search_query": "2 bedroom apartments windsor forest",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Windsor Forest",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Ascend at Savannah, located in the charming neighborhood of Windsor Forest.",
      "page_copy": "Ascend at Savannah offers beautifully designed 2 bedroom apartments nestled in the serene Windsor Forest neighborhood. Our community provides spacious living areas perfectly suited for families, roommates, or working professionals seeking comfort and convenience. Every unit is equipped with essential amenities, including a cooling air conditioning system, perfect for the warm Savannah summers.\n\nResidents at Ascend benefit from a plethora of community features such as a modern fitness center, engaging sports courts, and vibrant communal spaces like the playground and clubhouse. Additionally, our property includes practical amenities such as laundry facilities and a car wash area, further enhancing your living experience. Join the Ascend community and enjoy the best of Windsor Forest living with our 2 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Windsor Forest",
      "seo_description": "Find spacious 2 bedroom apartments in Windsor Forest at Ascend. Enjoy modern living with excellent amenities in a great Savannah location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192632",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-chatham-county",
      "search_query": "3 bedroom apartments chatham county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Chatham County",
      "h2_subtitle": "Discover expansive 3 bedroom apartments at Ascend at Savannah, located in desirable Chatham County.",
      "page_copy": "Searching for family-friendly homes? Our 3 bedroom apartments at Ascend at Savannah offer expansive living spaces designed to meet diverse needs. Situated in Chatham County, our community combines a convenient location with modern amenities, creating a welcoming environment for families and roommates alike. Each apartment features a reliable air conditioning system, ensuring comfort throughout the year.\n\nOur community offerings extend beyond the individual units. Residents can enjoy access to a fitness center, spacious clubhouse, and sports courts, all aimed at promoting an active lifestyle. The walk-up design, coupled with security systems, ensures easy living with peace of mind. Choose Ascend at Savannah for your new home in Chatham County and relish a harmonious blend of space, comfort, and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with brick facades and manicured landscaping.",
        "public_id": "019d0784-d85b-7781-9094-6b9f84618c30",
        "storage_key": "property/6737460151192632/019d0784-d85b-7781-9094-6b9f84618c30.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Chatham County",
      "seo_description": "Spacious 3 bedroom apartments in Chatham County at Ascend. Enjoy community amenities and comfort in a serene location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3361"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483162"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4857241"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W8BSHCVP"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "912-299-8255"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "912-299-8149"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "912-299-8256"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "912-913-5741"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "912-301-3635"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "912-299-8142"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "912-299-8266"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "912-299-8228"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "912-301-3637"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "912-299-8261"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "912-455-2223"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "912-491-2669"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "912-299-8246"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "912-406-0923"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "912-470-6729"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "912-616-2019"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "912-715-5832"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "912-301-3595"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "912-612-2396"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321198229"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "912-301-3597"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "912-922-3274"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "b9011ee6734edee1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "912-497-8248"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "912-299-8268"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "912-299-8131"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "912-452-2761"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "912-299-8278"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "912-301-3318"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "912-299-8172"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.ascendatsavannahapartments.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "912-301-3638"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "912-455-2223"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3361",
  "custom_repli_id": "5028483162",
  "custom_realpage_id": "4857241",
  "custom_knock_a_link": "https://www.ascendatsavannahapartments.com?utm_knock=a",
  "custom_knock_g_link": "https://www.ascendatsavannahapartments.com?utm_knock=g",
  "custom_knock_r_link": "https://www.ascendatsavannahapartments.com?utm_knock=r",
  "custom_knock_w_link": "https://www.ascendatsavannahapartments.com?utm_knock=w",
  "custom_knock_z_link": "https://www.ascendatsavannahapartments.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-W8BSHCVP",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.ascendatsavannahapartments.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.ascendatsavannahapartments.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.ascendatsavannahapartments.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.ascendatsavannahapartments.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.ascendatsavannahapartments.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.ascendatsavannahapartments.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "912-299-8255",
  "custom_knock_ads_link": "https://www.ascendatsavannahapartments.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.ascendatsavannahapartments.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "912-299-8149",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.ascendatsavannahapartments.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.ascendatsavannahapartments.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.ascendatsavannahapartments.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.ascendatsavannahapartments.com?utm_knock=psa",
  "custom_knock_r_number": "912-299-8256",
  "custom_knock_w_number": "912-913-5741",
  "custom_knock_z_number": "912-301-3635",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "912-299-8142",
  "custom_knock_amap_link": "https://www.ascendatsavannahapartments.com?utm_knock=amap",
  "custom_knock_ar_number": "912-299-8266",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "912-299-8228",
  "custom_knock_fb_number": "912-301-3637",
  "custom_knock_fl_number": "912-299-8261",
  "custom_knock_gp_number": "912-455-2223",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.ascendatsavannahapartments.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "912-491-2669",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.ascendatsavannahapartments.com?utm_knock=bcard",
  "custom_knock_bnr_number": "912-299-8246",
  "custom_knock_cfres_link": "https://www.ascendatsavannahapartments.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "912-406-0923",
  "custom_knock_lgp_number": "912-470-6729",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.ascendatsavannahapartments.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "912-616-2019",
  "custom_knock_psa_number": "912-715-5832",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "912-301-3595",
  "custom_knock_bandit_link": "https://www.ascendatsavannahapartments.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.ascendatsavannahapartments.com?utm_knock=flyers",
  "custom_knock_osoc_number": "912-612-2396",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321198229",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "912-301-3597",
  "custom_knock_cfres_number": "912-922-3274",
  "custom_knock_chatgpt_link": "https://www.ascendatsavannahapartments.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "b9011ee6734edee1",
  "custom_knock_dirmail_link": "https://www.ascendatsavannahapartments.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "912-497-8248",
  "custom_knock_propbro_link": "https://www.ascendatsavannahapartments.com?utm_knock=propbro",
  "custom_knock_bandit_number": "912-299-8268",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "912-299-8131",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.ascendatsavannahapartments.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "912-452-2761",
  "custom_knock_dirmail_number": "912-299-8278",
  "custom_knock_propbro_number": "912-301-3318",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "912-299-8172",
  "custom_knock_maintenance_link": "https://www.ascendatsavannahapartments.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "912-301-3638",
  "custom_ppc_tracking_phone_number": "912-455-2223"
};

export const generatedAt = '2026-10-07T17:12:41.312Z';
